/**
 * sidebarBindings.js — VRT presets, cinematic panel, W/L controls, tabs, modals, TF editor
 * Extracted from uiManager.js (декомпозиция God Object)
 */
// [11.1.10] Две строки ниже СТОЯЛИ ВНУТРИ докблока выше — между «/**» и «*/».
// Синтаксис от этого не страдает, файл разбирается, связывание проходит, но
// для браузера это комментарий: ни одно из шести имён не ввозилось. Падало на
// нажатии — «Вид А/Б», «А↔Б» и все кнопки сценариев умирали с ReferenceError,
// а getSidebarBindingsState ронял бы и проверку состояния (охрана «|| {}» от
// ReferenceError не спасает — до неё не доходит). Тот же род ошибки, что
// разобран в getSidebarBindingsState [11.0.2]: разбор проходит, падает вызов.
// Поймано tools/check_imports.mjs — ПОСЛЕ того, как его научили кириллице:
// прежде находка тонула в 141 ложной ошибке.
import { getWorkflow, getWindowPreset, CLINICAL_WORKFLOWS as CLINICAL_WORKFLOWS_РЕЕСТР } from '../core/presetsManager.js'; // [10.19.43] Сценарии; [11.0.2] реестр — под явным именем, чтобы его нельзя было спутать с местной копией, которой больше нет
import { setCameraA, setCameraB, toggleCameraAB, getCameraABState, setEndoscopyCamera, resetEndoscopyCamera } from '../core/viewportCamera.js'; // [10.19.43] Ракурсы; [12.0.51] эндоскопия

import {  setWindowLevel, set3DPreset, applyRenderPreset, applyWindowToSlices, applyAutoWindowToSlices, setStandardView, getRenderingEngine, getViewportIds, getVtkPlaneClass } from '../core/viewport.js';
import { плоскостиОсейНаМаппере } from '../core/viewportEffects.js'; // [12.0.57] сечения осей «Спец. режимов» — не наши, не сносить; setVolumeClipping ушёл к единственному хозяину ползунков (featureBindings)
import { getCinematicRenderer, find3DViewportId, cornerstone } from '../core/viewportState.js';
import { initTFEditor, toggleTFEditor, openWithPreset } from '../core/tfEditor.js';
// downloadBlob сюда не импортировался, а ниже стоит охрана
// `typeof downloadBlob === 'function'`. Необъявленное имя под typeof не падает —
// оно молча даёт 'undefined', охрана не пропускает, и снимок с записью
// кинематографического окна просто не сохранялись. Кнопка нажималась, кадр
// снимался, файла не появлялось и сообщения об ошибке тоже.
import { showToast, downloadBlob } from '../utils/helpers.js';
import { emit, on as busOn, EVENTS as BUS } from '../core/eventBus.js'; // [11.1.36] переприменение отсечения по событиям
import { callAPI } from '../core/viewerAPI.js';
import { updateWLOverlay } from './seriesPanel.js';
import { зажать, поКадрам, памятьОкна, подстроитьШкалу } from '../core/wlManual.js';   // [10.19.28] живой W/L и сброс; [11.1.17] шкала растёт под PET/авто
import { ГРУППЫ_ЧИПОВ, chipHtml, пределыШкалы } from '../core/wlChips.js';
import { setAnnotationStyle } from '../tools/toolManager.js';
import { setGlobalOpacityScale, setSoftTissueScale } from '../core/presets3d';
import { раскладкаДляПротокола } from '../core/hangingLayout.js'; // [12.0.51] честные протоколы
import { запомнитьПлоскости, стеречьОкно } from '../core/clipGuard.js'; // [12.0.51] отсечение не отдаётся камере
import { плоскостьОтсечения, плоскостьСоСтороны, плоскостиОкнаОбзора, маперПоддерживает, плоскостиСторон } from '../core/tableCrop.js';
import { контрастыДляМодальности, аппаратыДляМодальности, маскаДаты, проверитьДату } from '../core/reportCatalogs.js'; // [11.1.31] справочники бланка // [11.1.26] «Убрать стол»
import { прочитатьБланк, прочитатьПрофили, сохранитьПрофиль, удалитьПрофиль, разобратьФайлПрофилей, собратьФайлПрофилей, записатьПрофили, ШРИФТЫ, шрифтыБланка, логотипБланка, поляБланка } from '../core/reportBlank.js'; // [11.1.23] «Плотность тканей» // [11.1.21] стиль аннотаций проведён к движку // [11.1.17] единый каталог чипов — оба грида строятся из него
import { changeLayout } from './layoutManager.js';
import { log } from '../utils/logger.js';
import { ModalManager } from './modalManager.js';
// [12.0.18] Точный показ органов по маске сегментации — альтернатива
// порогу плотности для органных кнопок.
import { наборДляПресета, показатьОрганы, органыПоказаны, вернутьТелоИзОрганов, подписьМодели } from '../core/organIsolate3D.js';
import { ПО_РУССКИ as ПО_РУССКИ_ОРГАНЫ } from '../ai/organsMath.js';   // [12.0.28] имена органов в плашках
import { маршрутКнопки, фазаДляПресета, МАСКА_ПО_ФАЗЕ } from '../core/presetRouteCore.js';   // [12.0.26] маска или плотность
import { задатьКартуПресетов, погаситьПресетыБезИсследования } from './presetModality.js';   // [12.0.34] гасить пресеты чужой модальности
import { панельБезИсследования } from './modalityPanel.js';   // [12.0.55] панель по модальности серии
import { initSidebarSwap } from './sidebarSwap.js';   // [12.0.16]

// [FIX] AbortController для очистки всех addEventListener при destroy
let _ac = new AbortController();


const $ = (id) => document.getElementById(id);
const $$ = (sel) => document.querySelectorAll(sel);
/**
 * [11.0.2] Привязка с меткой: элемент помнит, какие события у него уже заняты.
 *
 * Так возник дубль всей кинематики. Этот хелпер вешал слушателя молча, а
 * второй набор привязок (indexBindings) проверял `dataset.bound` — метку,
 * которой здесь никто не ставил, — видел «свободно» и вешал свой поверх.
 * Двадцать два контрола слушались дважды, и вина была не в том наборе, а
 * здесь: тот, кто пришёл первым, не оставил следа.
 *
 * Метка раздельная по событию (`bound-click`, `bound-change`): один и тот же
 * элемент законно слушает и клик, и ввод. Повтор пишется в отладку, а не
 * молчит: если два модуля правда спорят за кнопку, это надо видеть.
 */
const on = (id, evt, fn) => {
  const el = $(id);
  if (!el) return;
  const метка = `bound${evt.charAt(0).toUpperCase()}${evt.slice(1)}`;
  if (el.dataset[метка]) { log.debug(`[sidebarBindings] ${id}: «${evt}» уже привязан — второй слушатель не вешаю`); return; }
  el.addEventListener(evt, fn, { signal: _getSignal() });
  el.dataset[метка] = '1';
};
const onAll = (sel, evt, fn) => $$(sel).forEach(el => el.addEventListener(evt, fn, { signal: _getSignal() }));
let _abortController = null;
function _getSignal() { if (!_abortController) _abortController = new AbortController(); return _abortController.signal; }
export function destroySidebarBindings() {
  _ac.abort(); _ac = new AbortController(); if (_abortController) { _abortController.abort(); _abortController = null; } }

let _activeVRTPreset = '';
const BUILTIN_VRT_PRESETS = [
  // CT — основные
  { id: 'ct-bone-3d', name: 'Кости 3D', color: '#eea' },
  { id: 'ct-bone-context', name: 'Кости контекст', color: '#dd8' },
  { id: 'ct-bone-hard', name: 'Кости жёсткие', color: '#cc6' },
  { id: 'ct-bone-warm', name: 'Кости тёплые', color: '#fb8' },
  { id: 'ct-skin', name: 'Кожа', color: '#fca' },
  { id: 'ct-skin-transparent', name: 'Кожа прозр.', color: '#fdb' },
  { id: 'ct-muscle', name: 'Мышцы', color: '#a66' },
  { id: 'ct-vascular', name: 'Сосуды', color: '#f66' },
  { id: 'ct-vascular-bone', name: 'Сосуды+Кости', color: '#f86' },
  { id: 'ct-coronary', name: 'Коронары', color: '#e55' },
  { id: 'ct-air', name: 'Дых. пути', color: '#6cf' },
  { id: 'ct-lung-3d', name: 'Лёгкие 3D', color: '#66f' },
  { id: 'ct-lung-surface', name: 'Лёгкие поверхн.', color: '#88f' },
  { id: 'ct-colon', name: 'Кишечник', color: '#a64' },
  { id: 'ct-overview', name: 'Обзорный', color: '#aac' },
  { id: 'ct-xray', name: 'Рентген', color: '#bbb' },
  { id: 'ct-density-map', name: 'Карта плотности', color: '#8cf' },
  // MRI
  { id: 'mri-brain-3d', name: 'MRI Мозг', color: '#caa' },
  { id: 'mri-wm-gm', name: 'WM/GM', color: '#aaa' },
  // Кардио / Ангио
  { id: 'cardiac-3d', name: 'Сердце 3D', color: '#f48' },
  { id: 'cardiac-fat', name: 'Кардио жир', color: '#fa6' },
  { id: 'angio-3d', name: 'Ангио 3D', color: '#f88' },
  { id: 'fetus', name: 'Плод 3D', color: '#fac' },
  // Custom
  { id: 'custom-01-ct-liver', name: 'Печень', color: '#a86' },
  { id: 'custom-02-ct-kidneys', name: 'Почки', color: '#a68' },
  { id: 'custom-03-ct-fat', name: 'Жир', color: '#ee8' },
  { id: 'custom-04-ct-brain-vessels', name: 'Сосуды мозга', color: '#c8f' },
  { id: 'custom-05-ct-carotid', name: 'Сонные арт.', color: '#f8a' },
  { id: 'custom-06-ct-dental', name: 'Стоматология', color: '#efa' },
  { id: 'custom-07-ct-fracture', name: 'Переломы', color: '#fe8' },
  { id: 'custom-08-ct-mip-pseudo', name: 'Псевдо-MIP', color: '#8ef' },
  { id: 'custom-09-mri-angio', name: 'MRI Ангио', color: '#f8c' },
  { id: 'custom-10-mri-t2-fluid', name: 'MRI T2', color: '#8af' },
  { id: 'custom-11-ct-cardiac-valves', name: 'Клапаны', color: '#f68' },
  { id: 'custom-12-ct-pulmonary-vessels', name: 'Лёг. сосуды', color: '#68f' },
  { id: 'custom-13-ct-bronchi-lumen', name: 'Бронхи', color: '#6ef' },
  { id: 'custom-14-ct-aorta-stent', name: 'Аорта+стент', color: '#f46' },
  { id: 'custom-15-ct-muscle-skeletal', name: 'Мышцы+скелет', color: '#a86' },
];
let _ctx = null;

/**
 * @param {Object} ctx
 * @param {function():string} ctx.getCurrentViewportId
 * @param {Object} ctx.VRT_PRESET_MAP
 */
export function initSidebarBindings(ctx) {
  _bindРакурсы(); _bindСценарии(); // [10.19.43]
  _ctx = ctx;
  задатьКартуПресетов(ctx?.VRT_PRESET_MAP);   // [12.0.34] чтобы знать модальность каждой кнопки
  bindVRTSection();
  bindCinematicPanel();
  построитьЧипыОкон();   // [11.1.17] сперва отрисовать чипы из каталога — привязки ниже вешаются на живые узлы
  // [12.0.35] При запуске исследования нет — пресеты серые, пока не откроется
  // серия (её модальность разберёт updateOverlays).
  // [12.0.38] Вызов — ПОСЛЕ построения чипов окна: они строятся здесь же, из
  // каталога, и раньше этой строки их в документе нет.
  погаситьПресетыБезИсследования();
  bindPresetChips();
  // [12.0.55] Исследования ещё нет — панель целиком: смотреть, что умеет
  // программа, можно и до снимка. Чипы окна уже построены (выше) — их метки
  // модальности разбираются вместе с остальной панелью.
  панельБезИсследования();
  bindCustomWL();
  bindRightTabs();
  bindPanelCollapses();
  bindModals();
  bindSidebarToggles();
  bindSliderUpdates();
  bindToggles();
  bindTFEditor();
  bindLeftPanelVRT();
  bindLeftPanelOrient();
  // [12.0.51] bindRulerMinimap() — удалена вместе с миникартой.
  bindHangingProtocols();
  initSidebarSwap();   // [12.0.16] обмен левой и правой панелей местами
}

export { openModal, closeModal, bindTFEditor };

// ============================================================
// VRT & ВИД SECTION — 3D presets, orientations, cinematic, fit
// ============================================================
function bindVRTSection() {
  // Right panel: Standard views (ANT, SUP, POST, LEFT, INF, RIGHT)
  onAll('.preset-chip[data-std-view]', 'click', (e) => {
    const view = e.currentTarget.dataset.stdView;
    if (_ctx.getCurrentViewportId()) {
      setStandardView(_ctx.getCurrentViewportId(), view);
      // [10.19.14] Было «Anterior/Posterior/Superior» латиницей — теперь по-русски.
      const ПОРУССКИ = { anterior: 'Спереди', posterior: 'Сзади', superior: 'Сверху',
        inferior: 'Снизу', left: 'Слева', right: 'Справа' };
      showToast(ПОРУССКИ[view] || String(view), 'info', 800);
    }
  });

  // [10.19.16] Обработчик кнопки «btn-cinematic-toggle» переехал в ui/featureBindings.js:
  // все входы в кинематографический рендеринг теперь идут одним путём через
  // ui/cinematicControl.js. Здесь он был отдельным и вёл себя иначе — печатал
  // «включён», когда рендерер оставался выключенным.

  // Right panel: Fit View


  // ══════════════════════════════════════════════════════════════
  // [12.0.18] ТОЧНЫЙ РЕЖИМ ОРГАННЫХ КНОПОК
  //
  // Пресет фильтрует по плотности и поэтому обязан показать соседа той же
  // плотности: селезёнка 40–55 HU и поясничная мышца 40–55 — одно и то же
  // число. В точном режиме та же кнопка берёт орган по маске сегментации,
  // где работает форма. Подписи кнопок при этом не меняются.
  // ══════════════════════════════════════════════════════════════

  /** [12.0.28] Русское имя органа для плашки. */
  const ИМЯ_ОРГАНА = (имя) => ПО_РУССКИ_ОРГАНЫ[имя] || имя;
  /** [12.0.28] Сколько ждать — те же слова, что в панели «Органы автоматом». */
  // [12.0.32] Печень: на машине владельца liver_unet шёл 217 с на 818 срезов —
  // «около минуты» было моей ошибкой оценки.
  const ВРЕМЯ_МОДЕЛИ = (модель) => (модель === 'liver-unet' ? 'около 3–4 минут' : модель === 'organs-6mm' ? 'секунды'
    : модель === 'organs-3mm' ? 'минуты' : /^organs-15mm-/.test(String(модель)) ? 'около четверти часа на область' : 'время неизвестно');

  /** Включён ли тумблер «Точно (по маске)». */
  const _точныйРежим = () => !!$('vrt-organ-exact')?.classList.contains('on');

  /** Набор органов для кнопки: ключом может быть и сам data-атрибут, и cs3d. */
  const _наборКнопки = (preset, cs3d) => наборДляПресета(preset) || наборДляПресета(cs3d);

  /**
   * Показать орган по маске. Возвращает true, если показ состоялся и обычный
   * пресет применять уже не нужно.
   */
  async function _органПоМаске(ключ, набор) {
    // [12.0.28] Модель — та, что врач выбрал в панели «Органы автоматом».
    // Прежде кнопка всегда гнала грубую 6 мм и не видела готовой разметки.
    let модель = null;
    try { модель = (await import('./organsPick.js')).модельПанели(); } catch (e) { модель = null; }
    // [12.0.32] Держать снимок в памяти, пока считают модели, и проверить
    // после — та же защита, что у панели «Органы автоматом» с 11.1.88. Без
    // неё модель 3 мм подняла память до 88%, страж выбросил снимок, и тело
    // исчезло из окна у владельца.
    const страж = await import('./snapshotGuard.js');
    const держим = await страж.держатьСнимок();
    let р;
    try {
      р = await показатьОрганы(ключ, {
      модель,
      копить: !!$('vrt-organ-add')?.classList.contains('on'),   // [12.0.33] заменять или добавлять
      // [12.0.29] План приходит до счёта (и второй раз — перед общим
      // прогоном): что взято готовым, что считается и сколько ждать.
      план: ({ готовые = [], печень, печеньЗамена, считать = [] }) => {
        const части = [];
        if (готовые.length) части.push(`по готовой разметке — ${готовые.map((г) => ИМЯ_ОРГАНА(г.орган)).join(', ')}`);
        if (печень) части.push(`печень — ${подписьМодели(печень)}, ${ВРЕМЯ_МОДЕЛИ(печень)}`);
        if (печеньЗамена) части.push(`отдельная модель печени не сработала (${печеньЗамена}) — печень считается общей моделью`);
        for (const г of считать) {
          части.push(`размечаю: ${г.органы.map(ИМЯ_ОРГАНА).join(', ')} — ${подписьМодели(г.модель)}`
            + `${г.замена ? ' (выбранная в панели модель эту структуру не размечает)' : ''}`
            + `, ${ВРЕМЯ_МОДЕЛИ(г.модель)}`);
        }
        if (части.length) showToast(`${набор.подпись}: ${части.join('; ')}`,
          печеньЗамена ? 'warning' : 'info', (печень || считать.length) ? 7000 : 2500);
      },
      ход: (доля, текст) => {
        // Сообщаем только середину пути: начало и конец и так видны по плашкам.
        if (доля > 0.05 && доля < 0.99) showToast(`${Math.round(доля * 100)}% · ${текст}`, 'info', 900);
      },
      });
    } finally {
      await страж.отпуститьСнимок(держим);
    }
    // Снимок всё-таки выгрузился — страж вернёт серию и скажет об этом сам.
    // [12.0.37] Поверхности при перечитывании серии пропадают, и врачу
    // приходилось жать кнопку второй раз (владелец: «всё перезагрузилось и
    // опять сработал пресет „Обзорный“, только при повторном нажатии
    // появились органы»). Теперь кнопка сама показывает органы ещё раз: маски
    // уже в реестре, модели второй раз не считают.
    let пропадал = false;
    try { пропадал = (await import('../core/viewport.js')).окнаБезДанных().length > 0; } catch (e) { пропадал = false; }
    const снимокЦел = await страж.проверитьСнимок('органную кнопку');
    if (снимокЦел && пропадал) {
      log.info('[Органы-3D] снимок возвращали — показываю органы ещё раз по готовой разметке');
      const держим2 = await страж.держатьСнимок();
      try {
        р = await показатьОрганы(ключ, { модель, копить: !!$('vrt-organ-add')?.classList.contains('on') });
      } finally {
        await страж.отпуститьСнимок(держим2);
      }
    }
    if (!снимокЦел || !р) return false;
    if (!р.ок) {
      showToast(`Органы по маске: ${р.причина}`, 'warning', 6000);
      return false;
    }
    // [12.0.33] И размах по главной оси — чтобы размеры сравнивать по числам,
    // а не на глаз по картинке.
    const поОрганам = (р.органы || []).map((о) => `${ИМЯ_ОРГАНА(о.орган)} ${о.мл.toFixed(0)} мл`
      + (о.размах ? `, ${(о.размах[0] / 10).toFixed(1)} см` : '')).join(' · ');
    // [12.0.27] Говорим, В КАКОМ окне смотреть: органы легли в невидимое
    // врачу окно, и плашка с объёмами выглядела как работа вхолостую.
    const где = р.окно === 'view-3d' ? ' — окно «3D · Пресет»' : (р.окно ? ' — объёмное окно' : '');
    // [12.0.28] Грубая сетка — предупредить словами: кубики по 6 мм и
    // объёмы на ней грубые, а подробная разметка — в панели.
    const грубо = (р.посчитано || []).some((г) => г.модель === 'organs-6mm')
      || (р.готовые || []).some((г) => г.шагМм >= 6);
    showToast(`${набор.подпись}: ${поОрганам}${где}`
      + (грубо ? '. Грубая модель 6 мм: форма ступеньками, объёмы приблизительные. Подробнее — выберите '
        + '«подробная 3 мм» или «полная 1,5 мм» в «Органы автоматом» и нажмите кнопку снова' : ''),
    грубо ? 'warning' : 'success', грубо ? 9000 : 4000);
    return true;
  }

  /** Тело показано обратно, если на экране были органы. */
  async function _вернутьТелоЕслиНадо() {
    if (!органыПоказаны()) return;
    const р = await вернутьТелоИзОрганов();
    if (!р.ок) log.debug('[Органы-3D] возврат тела:', р.причина);
  }

  /**
   * [12.0.26] Фаза контрастирования текущей серии — тем же решением, что в
   * отчёте о качестве (теги → описание серии → отсутствие признаков, 12.0.24).
   * Нужна правилу «печень вне портальной фазы — только маской». Не вышло
   * узнать — null, и кнопка работает по плотности, как раньше.
   */
  async function _фазаТекущейСерии() {
    try {
      const uid = _ctx.getCurrentSeries?.();
      const серия = (_ctx.getAllSeries?.() || []).find((с) => с.seriesUID === uid);
      if (!серия) return null;
      const первый = (серия.images || серия.files || [])[0]?.imageId;
      let nat = null;
      try { nat = первый ? cornerstone.metaData.get('instance', первый) : null; } catch (e) { nat = null; }
      const тег = (kw) => { let v = nat?.[kw]; if (Array.isArray(v)) v = v[0]; return v == null ? '' : String(v).trim(); };
      const м = await import('../storage/studyQualityAnalyzer.js');
      const A = м.StudyQualityAnalyzer || м.default;
      const пар = {
        contrastAgent: тег('ContrastBolusAgent'), contrastRoute: тег('ContrastBolusRoute'),
        seriesDesc: серия.seriesDesc || тег('SeriesDescription'), protocolName: тег('ProtocolName'),
        studyDesc: серия.studyDesc || тег('StudyDescription'),
      };
      const к = A.решитьКонтраст(пар);
      const ф = A.detectContrastPhase({ ...пар, hasContrast: к.есть, contrastSource: к });
      return фазаДляПресета(ф?.phase);
    } catch (e) {
      log.debug('[Органы-3D] фаза серии:', e.message);
      return null;
    }
  }

  /**
   * [12.0.26] Нажатие органной (и любой) кнопки 3D-пресета — ОДНО на обе
   * панели. Прежде левая и правая панели держали по копии ветвления, и
   * правило «маска или плотность» пришлось бы писать дважды.
   *
   *   · тумблер «Точно (по маске)» включён и у кнопки есть набор — маска,
   *     как с 12.0.18;
   *   · поджелудочная (и набор с ней) — маска ВСЕГДА, печень — на нативе и
   *     артериальной фазе: плотностью их не выделить (presetRouteCore.js).
   *     Не вышла маска — говорим почему и показываем по плотности;
   *   · остальное — пресет по плотности; про «Бронхи» и «Плод» — правда
   *     в подсказке.
   */
  async function _органнаяКнопка(подпись, preset, p) {
    const набор = _наборКнопки(preset, p.cs3d);
    const ключНабора = набор ? (набор === наборДляПресета(preset) ? preset : p.cs3d) : preset;
    const тумблер = _точныйРежим();
    const фаза = (набор && !тумблер && МАСКА_ПО_ФАЗЕ[ключНабора]) ? await _фазаТекущейСерии() : null;
    const м = маршрутКнопки({ ключ: ключНабора, тумблер, естьНабор: !!набор, фаза });

    if (м.путь === 'маска') {
      if (м.сам) showToast(`${набор.подпись}: ${м.причина} — показываю по маске сегментации`, 'info', 4500);
      const вышло = await _органПоМаске(ключНабора, набор);
      if (вышло || !м.сам) return;   // с тумблером отказ уже сказан — как в 12.0.18
      showToast(`${набор.подпись}: маску построить не удалось — показываю по плотности. `
        + 'Орган будет вместе с соседями той же плотности', 'warning', 6000);
    }

    // Пресет по плотности. Сперва вернуть тело, иначе пресет лёг бы на маску.
    await _вернутьТелоЕслиНадо();
    const r = applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
    if (м.подсказка) showToast(м.подсказка, 'info', 7000);
    else if (м.путь !== 'маска') showToast(_presetToast(подпись, r), 'info', 1200);
    // [11.0.2] Пресет переписал кривую прозрачности — значит ползунки «Объём
    // 3D» показывают уже не то, что на экране. Подтягиваем их под новую
    // кривую, иначе подпись врёт (см. оговорку в _подключитьОбъём3D).
    setTimeout(() => window.__волОбъёмСнятьСКривой?.(), 120);
  }

  // Left panel: VRT preset buttons (colored)
  onAll('.sl-vrt-btn[data-render-preset]', 'click', (e) => {
    $$('.sl-vrt-btn').forEach(b => b.classList.remove('active'));
    $$('.preset-chip[data-render-preset]').forEach(b => b.classList.remove('active'));
    e.currentTarget.classList.add('active');
    const preset = e.currentTarget.dataset.renderPreset;
    const p = _ctx.VRT_PRESET_MAP[preset] || { cs3d: preset, ww: 400, wc: 40 };
    log.debug('[FIX-5] VRT preset:', preset, '→', p.cs3d);
    // [10.0.2] Пресет объёмной отрисовки — в объёмное окно, и только туда.
    // set3DPreset рядом больше не зовём: он бил в ПЕРВОЕ объёмное окно, а в
    // раскладке из шести адресат — «3D · Пресет», иначе оба окна становились
    // одинаковыми и вторая панель теряла смысл.
    _последнийVRTПресет = { cs3d: p.cs3d, ww: p.ww, wc: p.wc };   // [11.1.23] для пере-применения слайдером плотности
    // [12.0.26] Маска или плотность — одно правило на обе панели кнопок.
    _органнаяКнопка(e.currentTarget.textContent, preset, p);
  });

  // Right panel + mobile: preset-chip 3D render presets
  onAll('.preset-chip[data-render-preset]', 'click', (e) => {
    $$('.sl-vrt-btn[data-render-preset]').forEach(b => b.classList.remove('active'));
    $$('.preset-chip[data-render-preset]').forEach(b => b.classList.remove('active'));
    e.currentTarget.classList.add('active');
    const preset = e.currentTarget.dataset.renderPreset;
    const p = _ctx.VRT_PRESET_MAP[preset] || { cs3d: preset, ww: 400, wc: 40 };
    log.debug('[FIX-5] VRT preset (chip):', preset, '→', p.cs3d);
    _последнийVRTПресет = { cs3d: p.cs3d, ww: p.ww, wc: p.wc };   // [11.1.23]
    _органнаяКнопка(e.currentTarget.textContent, preset, p);   // [12.0.26] см. левую панель
  });

  // [12.0.18] Тумблер точного режима. Помечаем хозяина, иначе общий
  // перещёлкиватель bindToggles сбросит класс сразу после обработчика.
  if ($('vrt-organ-exact')) $('vrt-organ-exact').dataset.хозяин = 'sidebarBindings/ТочноПоМаске';
  // [12.0.33] «Добавлять органы»: хозяин — этот модуль (читается при нажатии
  // органной кнопки), общему перещёлкивателю его не отдаём.
  if ($('vrt-organ-add')) $('vrt-organ-add').dataset.хозяин = 'sidebarBindings/ДобавлятьОрганы';
  on('vrt-organ-add', 'click', (e) => {
    const кнопка = e.currentTarget;
    const вкл = !кнопка.classList.contains('on');
    кнопка.classList.toggle('on', вкл);
    кнопка.setAttribute('aria-checked', String(вкл));
    showToast(вкл ? 'Органные кнопки добавляют органы к уже показанным'
      : 'Органная кнопка заменяет показанные органы своими', 'info', 3000);
  });
  on('vrt-organ-exact', 'click', async (e) => {
    const кнопка = e.currentTarget;
    const вкл = !кнопка.classList.contains('on');
    кнопка.classList.toggle('on', вкл);
    кнопка.setAttribute('aria-checked', String(вкл));
    if (вкл) {
      showToast('Точный режим: органные кнопки пойдут по маске сегментации', 'info', 3500);
      return;
    }
    // Выключили — возвращаем тело и последний обычный пресет: иначе в окне
    // осталась бы маска, а кнопки показывали бы другое.
    await _вернутьТелоЕслиНадо();
    if (_последнийVRTПресет) {
      applyRenderPreset(_последнийVRTПресет.cs3d, { ww: _последнийVRTПресет.ww, wc: _последнийVRTПресет.wc });
    }
    showToast('Обычный режим: показ по плотности', 'info', 2000);
  });

  // [12.0.32] «Убрать органы»: органы теперь копятся, и очистить их нужно
  // отдельной кнопкой. Тело и разметка остаются.
  on('btn-organs-clear', 'click', async () => {
    if (!органыПоказаны()) { showToast('Органов на экране нет', 'info', 2000); return; }
    const р = await вернутьТелоИзОрганов();
    showToast(р.ок ? 'Органы убраны — тело и разметка остались' : `Не удалось убрать органы: ${р.причина}`,
      р.ок ? 'info' : 'warning', 3000);
  });

  // Left panel: Orientation buttons
  onAll('.sl-orient-btn[data-std-view]', 'click', (e) => {
    const view = e.currentTarget.dataset.stdView;
    if (_ctx.getCurrentViewportId()) {
      setStandardView(_ctx.getCurrentViewportId(), view);
      showToast(`📷 ${view.charAt(0).toUpperCase() + view.slice(1)}`, 'info', 800);
    }
  });

  // [10.19.16] Обработчик кнопки «btn-cinematic-left» переехал в ui/featureBindings.js:
  // все входы в кинематографический рендеринг теперь идут одним путём через
  // ui/cinematicControl.js. Здесь он был отдельным и вёл себя иначе — печатал
  // «включён», когда рендерер оставался выключенным.

  // [10.19.16] «Вписать» была молчаливой пустышкой.
  //
  // Прежний код брал ТОЛЬКО активное окно: `re.getViewport(getCurrentViewportId())`.
  // Пока врач не щёлкнул по какому-нибудь окну, активного окна нет — идентификатор
  // пустой, `getViewport(undefined)` возвращает ничего, и обработчик молча
  // заканчивался. Измерено на живой сборке: камера не менялась, плашек ноль.
  // Именно про эту кнопку сказано «пустышка», и это была правда.
  //
  // Теперь: если активное окно есть — вписывается оно, иначе ВСЕ окна раскладки.
  // И кнопка всегда отвечает числом, сколько окон вписала.
  on('btn-fit-view-left', 'click', () => {
    const re = getRenderingEngine();
    if (!re) { showToast('Сначала откройте исследование — вписывать нечего', 'warning', 3000); return; }
    const активное = _ctx.getCurrentViewportId?.();
    const цели = активное ? [активное] : (getViewportIds() || []);
    let вписано = 0;
    for (const id of цели) {
      try {
        const vp = re.getViewport(id);
        if (!vp) continue;
        vp.resetCamera();
        vp.render();
        вписано++;
      } catch (e) { log.debug('[Вписать]', e.message); }
    }
    if (!вписано) { showToast('Вписывать нечего: в раскладке нет окон с изображением', 'warning', 3000); return; }
    showToast(активное ? 'Изображение вписано в активное окно' : `Изображение вписано во все окна: ${вписано}`, 'info', 2000);
  });

  // VRT Preset Manager
  on('btn-vrt-manager', 'click', () => {
    openVRTPresetManager();
    openModal('modal-vrt-presets');
  });

  // [10.0.13] «3D пресет» разворачивает ШЕСТОЕ окно MPR 6 во весь экран.
  //
  // Раньше кнопка строила своё одиночное объёмное окно и сама ставила туда
  // пресет. Трижды подряд оно чем-то отличалось от рабочего шестого окна, и
  // на МР выходил полупрозрачный блок вместо головы. Своего пути больше нет:
  // кнопка показывает тот самый вьюпорт, а не его копию.
  on('btn-preset-3d', 'click', () => {
    window.MikhmelViewer?.showPreset3DFullscreen?.();
  });
}

// ============================================================
// CINEMATIC PANEL — полная панель управления Cinematic Rendering
// ============================================================
function bindCinematicPanel() {
  // [12.0.51] Кэш рендерера (_crCache) УБРАН. Он запоминал первый попавшийся
  // рендерер навсегда, а рендерер пересоздаётся: смена раскладки и закрытие
  // исследования его уничтожают (viewport.js, cleanupViewports → dispose),
  // следующий «Рендер» создаёт новый. Ползунки тонкой настройки, «Пресет»,
  // «Разделение», «Скриншот» и «Запись» после этого говорили с УНИЧТОЖЕННЫМ
  // рендерером: ползунок двигался, картинка — нет. Теперь рендерер берётся у
  // хозяина при каждом обращении, уничтоженный не считается.
  const getCR = () => {
    try {
      const cr = getCinematicRenderer();
      if (cr && !cr.isDisposed?.() && typeof cr.setParams === 'function') return cr;
    } catch (e) { log.debug("[sidebarBindings]", e.message); }
    return null;
  };
  const getCRAsync = async () => getCR();

  // Гарантированный toggle через API (cinematicToggle всегда работает)
  /**
   * [11.0.2] Обработчик кнопки «Включить/Выключить» (cine-toggle-btn) УДАЛЁН:
   * такой кнопки нет в разметке с 10.19.19.
   *
   * Тогда её заменили честной парой «Рендер» / «Стоп» (btn-render-start,
   * btn-render-stop): у двух явных кнопок нет состояния, которым можно
   * соврать, а одна переключающаяся врала — показывала «Выключить», когда
   * включение не удалось. Кнопку убрали, а сорок пять строк её обработчика
   * остались висеть здесь вместе с помощником ensureToggle: код исполнялся при
   * каждом запуске, искал элемент, не находил и молча выходил.
   *
   * Сторож не ловил это по правилу «код сам создаёт элемент»: имя лежало в
   * массиве подписей _syncUI (indexBindings) как `id: '…'`, и запись в объекте
   * принималась за создание. Дыра закрыта в uiwiring_test [11.0.2].
   */

  // Preset selector
  on('cine-preset', 'change', async () => {
    const sel = $('cine-preset');
    if (!sel) return;
    let cr = getCR() || await getCRAsync();
    if (cr) {
      cr.setPreset(sel.value);
    } else {
      try { await window.MikhmelViewer?.cinematicPreset?.(sel.value); } catch (e) { log.debug("[sidebarBindings]", e.message); }
    }
    showToast(`🎬 ${sel.options[sel.selectedIndex].text}`, 'info', 800);
    setTimeout(() => _syncCinematicSliders(), 50);
  });

  // Slider helper
  function bindSlider(sliderId, valId, realMin, realMax, decimals, setFn) {
    const slider = $(sliderId);
    const valEl = $(valId);
    if (!slider) return;
    slider.addEventListener('input', () => {
      const pct = parseFloat(slider.value);
      const range = parseFloat(slider.max) - parseFloat(slider.min);
      const real = realMin + (pct - parseFloat(slider.min)) / range * (realMax - realMin);
      if (valEl) valEl.textContent = real.toFixed(decimals);
      setFn(real);
    }, { signal: _ac.signal });
  }

  // Param setter
  const setP = (path, val) => {
    const parts = path.split('.');
    const obj = {};
    let cur = obj;
    for (let i = 0; i < parts.length - 1; i++) { cur[parts[i]] = {}; cur = cur[parts[i]]; }
    cur[parts[parts.length - 1]] = val;
    getCR()?.setParams(obj);
  };
  /** [12.0.51] Несколько полей одного раздела за раз (значение + включатель). */
  const setPs = (obj) => { getCR()?.setParams(obj); };

  // Bind all sliders
  bindSlider('cine-ssao-radius', 'cine-ssao-radius-val', 1, 20, 0, v => setP('ssao.radius', v));
  bindSlider('cine-ssao-intensity', 'cine-ssao-intensity-val', 0, 1, 2, v => setP('ssao.intensity', v));
  bindSlider('cine-ssao-samples', 'cine-ssao-samples-val', 4, 32, 0, v => setP('ssao.samples', Math.round(v)));
  bindSlider('cine-bloom-threshold', 'cine-bloom-threshold-val', 0, 1, 2, v => setP('bloom.threshold', v));
  bindSlider('cine-bloom-intensity', 'cine-bloom-intensity-val', 0, 1, 2, v => setP('bloom.intensity', v));
  bindSlider('cine-exposure', 'cine-exposure-val', 0.5, 3, 1, v => setP('toneMap.exposure', v));
  bindSlider('cine-gamma', 'cine-gamma-val', 1, 3, 1, v => setP('toneMap.gamma', v));
  bindSlider('cine-sharpen', 'cine-sharpen-val', 0, 1, 2, v => setP('sharpen', v));
  bindSlider('cine-vignette', 'cine-vignette-val', 0, 1, 2, v => setP('vignette.intensity', v));
  bindSlider('cine-saturation', 'cine-saturation-val', 0, 2, 2, v => setP('colorGrade.saturation', v));
  bindSlider('cine-contrast', 'cine-contrast-val', 0.5, 2, 2, v => setP('colorGrade.contrast', v));
  bindSlider('cine-temperature', 'cine-temperature-val', -1, 1, 1, v => setP('colorGrade.temperature', v));
  bindSlider('cine-dof', 'cine-dof-val', 0, 1, 2, v => setP('dof.intensity', v));
  bindSlider('cine-dof-focus', 'cine-dof-focus-val', 0, 1, 2, v => setP('dof.focus', v));
  bindSlider('cine-edge', 'cine-edge-val', 0, 1, 2, v => setP('edge.intensity', v));
  bindSlider('cine-chromab', 'cine-chromab-val', 0, 1, 2, v => setP('chromAb', v));
  bindSlider('cine-grain', 'cine-grain-val', 0, 1, 2, v => setP('grain', v));

  // [ENTERPRISE v8] SSR
  // [12.0.51] Отражения, туман и боке рисуются ТОЛЬКО при `enabled` (оба
  // движка: cinematicRendering.js _chainPass и WebGL2: `p.ssr?.enabled`,
  // `p.fog?.enabled`, `p.bokeh?.enabled`), а ползунки писали одну
  // интенсивность — включатель не ставил никто, и шесть ползунков ничего не
  // меняли никогда. Теперь ненулевая интенсивность (плотность, размер)
  // включает проход, ноль — выключает.
  bindSlider('cine-ssr-intensity', 'cine-ssr-intensity-val', 0, 1, 2, v => setPs({ ssr: { intensity: v, enabled: v > 0.001 } }));
  bindSlider('cine-ssr-roughness', 'cine-ssr-roughness-val', 0, 1, 2, v => setP('ssr.roughness', v));
  bindSlider('cine-ssr-dist', 'cine-ssr-dist-val', 5, 60, 0, v => setP('ssr.maxDist', v));

  // [ENTERPRISE v8] Volumetric Fog
  bindSlider('cine-fog-density', 'cine-fog-density-val', 0, 0.5, 2, v => setPs({ fog: { density: v, enabled: v > 0.001 } }));
  // [12.0.51] Было 0.5…5 при подписи по умолчанию «2.0» у отметки 200: первое
  // же касание показывало 2.3, а сверка с рендерером (_syncCinematicSliders)
  // ставила ползунок по формуле «спад × 100». Шкала одна: отметка/100.
  bindSlider('cine-fog-falloff', 'cine-fog-falloff-val', 0, 5, 1, v => setP('fog.falloff', Math.max(0.05, v)));
  bindSlider('cine-fog-height', 'cine-fog-height-val', 0, 1, 2, v => setP('fog.height', v));

  // [ENTERPRISE v8] Color LUT
  on('cine-lut-mode', 'change', () => {
    const sel = $('cine-lut-mode');
    if (sel) setP('lut.mode', parseInt(sel.value));
  });
  bindSlider('cine-lut-intensity', 'cine-lut-intensity-val', 0, 1, 2, v => setP('lut.intensity', v));

  // [ENTERPRISE v8] Bokeh DOF
  // [12.0.51] Шкала 0…1 (была 0.1…1 при подписи «0.50» у отметки 50 — та же
  // рассинхронизация, что у спада тумана). 0 — боке выключено.
  bindSlider('cine-bokeh-size', 'cine-bokeh-size-val', 0, 1, 2, v => setPs({ bokeh: { size: Math.max(0.01, v), enabled: v > 0.001 } }));
  bindSlider('cine-bokeh-bright', 'cine-bokeh-bright-val', 0, 5, 1, v => setP('bokeh.bright', v));

  // Tone map mode
  on('cine-tonemap', 'change', () => {
    const sel = $('cine-tonemap');
    if (sel) setP('toneMap.mode', parseInt(sel.value));
  });

  // Split compare
  const splitSlider = $('cine-split');
  const splitVal = $('cine-split-val');
  if (splitSlider) {
    splitSlider.addEventListener('input', async () => {
      const v = parseFloat(splitSlider.value) / 100;
      if (splitVal) splitVal.textContent = Math.round(v * 100) + '%';
      const cr = getCR() || await getCRAsync();
      if (cr) cr.setSplitCompare(v);
    }, { signal: _ac.signal });
  }

  /**
   * [11.0.2] Распаковка ответа рендерера.
   *
   * Он отвечает не значением, а обёрткой `{ success, value }` либо
   * `{ success: false, error }` (cinematicRendering.js:51) — так у него
   * устроены все 33 возврата. Скриншот и запись брали ответ как есть и
   * отдавали обёртку в downloadBlob. Там охрана `!blob || blob.size === 0`
   * обёртку пропускала (`size` у неё нет вовсе), и URL.createObjectURL падал
   * с TypeError. Файл не сохранялся НИКОГДА, а на экране не было даже ошибки:
   * исключение уходило в необработанный промис.
   */
  const развернуть = (ответ) => {
    if (ответ instanceof Blob) return { ok: true, blob: ответ };            // на случай, если метод вернёт напрямую
    if (ответ && typeof ответ === 'object' && 'success' in ответ) {
      return ответ.success ? { ok: true, blob: ответ.value } : { ok: false, причина: ответ.error || 'причина не названа' };
    }
    return { ok: false, причина: 'рендерер ответил непонятным значением' };
  };

  // Screenshot
  on('cine-screenshot-btn', 'click', async () => {
    const cr = getCR() || await getCRAsync();
    if (!cr) { showToast('🎬 Кинематографический рендеринг не активен', 'warning', 1500); return; }
    const р = развернуть(await cr.captureScreenshot({ watermark: 'Mikhmel DICOM Viewer' }));
    if (!р.ok) { showToast(`📷 Снимок не сделан: ${р.причина}`, 'error', 3000); return; }
    if (!(р.blob instanceof Blob) || р.blob.size === 0) { showToast('📷 Снимок вышел пустым — кадр ещё не готов', 'warning', 3000); return; }
    downloadBlob(р.blob, `cinematic_${Date.now()}.png`);
    showToast('📷 Скриншот сохранён', 'success', 1500);
  });

  // Record
  // [12.0.51] Подпись кнопки возвращается ИСХОДНОЙ разметкой (значок + «Запись»),
  // а не текстом «🔴 Запись»: после первой записи значок пропадал навсегда.
  const _записьИсходно = $('cine-record-btn')?.innerHTML || 'Запись';
  on('cine-record-btn', 'click', async () => {
    const cr = getCR() || await getCRAsync();
    const btn = $('cine-record-btn');
    if (!cr) {
      if (btn) btn.innerHTML = _записьИсходно;   // рендерер уничтожен посреди записи — кнопка не врёт «Стоп»
      showToast('🎬 Кинематографический рендеринг не активен', 'warning', 1500); return;
    }
    if (cr.isRecording()) {
      const р = развернуть(await cr.stopRecording());
      if (btn) btn.innerHTML = _записьИсходно;
      if (!р.ok) { showToast(`🎬 Запись не сохранена: ${р.причина}`, 'error', 3000); return; }
      if (!(р.blob instanceof Blob) || р.blob.size === 0) { showToast('🎬 Записывать было нечего — файл пуст', 'warning', 3000); return; }
      downloadBlob(р.blob, `cinematic_${Date.now()}.webm`);
      showToast('🎬 Видео сохранено', 'success', 1500);
    } else {
      // Старт тоже отвечает обёрткой: «уже пишем», «нет канвы», «MediaRecorder
      // не поддержан». Раньше ответ выбрасывался, кнопка меняла подпись на
      // «Стоп» — и человек считал, что запись идёт, когда она не началась.
      const старт = cr.startRecording();
      if (старт && старт.success === false) {
        showToast(`🎬 Запись не началась: ${старт.error || 'причина не названа'}`, 'error', 3000);
        return;
      }
      if (btn) btn.textContent = '⏹ Стоп';
      showToast('🔴 Запись...', 'info', 1500);
    }
  });
}

// Синхронизация ползунков панели с текущими параметрами CinematicRenderer
async function _syncCinematicSliders() {
  try {
    let cr = getCinematicRenderer();
    if (!cr) {
      try { cr = await window.MikhmelViewer?._getCinematicRenderer?.(); } catch (e) { log.debug("[sidebarBindings]", e.message); }
    }
    if (!cr) return;
    const p = cr.getParams();
    const set = (id, val, display) => {
      const el = document.getElementById(id);
      const valEl = document.getElementById(id + '-val');
      if (el) el.value = val;
      if (valEl) valEl.textContent = display;
    };
    if (p.ssao) {
      set('cine-ssao-radius', p.ssao.radius || 8, p.ssao.radius || 8);
      set('cine-ssao-intensity', Math.round((p.ssao.intensity || 0) * 100), (p.ssao.intensity || 0).toFixed(2));
      set('cine-ssao-samples', p.ssao.samples || 16, p.ssao.samples || 16);
    }
    if (p.bloom) {
      set('cine-bloom-threshold', Math.round((p.bloom.threshold || 0) * 100), (p.bloom.threshold || 0).toFixed(2));
      set('cine-bloom-intensity', Math.round((p.bloom.intensity || 0) * 100), (p.bloom.intensity || 0).toFixed(2));
    }
    if (p.toneMap) {
      const tmSel = document.getElementById('cine-tonemap');
      if (tmSel) tmSel.value = String(p.toneMap.mode || 0);
      set('cine-exposure', Math.round((p.toneMap.exposure || 1) / 3 * 300), (p.toneMap.exposure || 1).toFixed(1));
      set('cine-gamma', Math.round((p.toneMap.gamma || 2.2) / 3 * 300), (p.toneMap.gamma || 2.2).toFixed(1));
    }
    set('cine-sharpen', Math.round((p.sharpen || 0) * 100), (p.sharpen || 0).toFixed(2));
    if (p.vignette) set('cine-vignette', Math.round((p.vignette.intensity || 0) * 100), (p.vignette.intensity || 0).toFixed(2));
    if (p.colorGrade) {
      set('cine-saturation', Math.round((p.colorGrade.saturation || 1) * 100), (p.colorGrade.saturation || 1).toFixed(2));
      set('cine-contrast', Math.round(((p.colorGrade.contrast || 1) - 0.5) / 1.5 * 150 + 50), (p.colorGrade.contrast || 1).toFixed(2));
      set('cine-temperature', Math.round((p.colorGrade.temperature || 0) * 100), (p.colorGrade.temperature || 0).toFixed(1));
    }
    if (p.dof) {
      set('cine-dof', Math.round((p.dof.intensity || 0) * 100), (p.dof.intensity || 0).toFixed(2));
      set('cine-dof-focus', Math.round((p.dof.focus || 0.5) * 100), (p.dof.focus || 0.5).toFixed(2));
    }
    if (p.edge) set('cine-edge', Math.round((p.edge.intensity || 0) * 100), (p.edge.intensity || 0).toFixed(2));
    set('cine-chromab', Math.round((p.chromAb || 0) * 100), (p.chromAb || 0).toFixed(2));
    set('cine-grain', Math.round((p.grain || 0) * 100), (p.grain || 0).toFixed(2));
    // [ENTERPRISE v8] SSR
    if (p.ssr) {
      // [12.0.51] Выключенный проход показывается нулём: иначе ползунок
      // показывал бы «0.30» при выключенных отражениях.
      const и = p.ssr.enabled ? (p.ssr.intensity || 0) : 0;
      set('cine-ssr-intensity', Math.round(и * 100), и.toFixed(2));
      set('cine-ssr-roughness', Math.round((p.ssr.roughness ?? 0.5) * 100), (p.ssr.roughness ?? 0.5).toFixed(2));
      set('cine-ssr-dist', p.ssr.maxDist || 30, p.ssr.maxDist || 30);
    }
    // [ENTERPRISE v8] Fog
    if (p.fog) {
      const п = p.fog.enabled ? (p.fog.density || 0) : 0;   // [12.0.51] выключен — ноль
      set('cine-fog-density', Math.round(п * 200), п.toFixed(2));
      set('cine-fog-falloff', Math.round((p.fog.falloff ?? 2) / 5 * 500), (p.fog.falloff ?? 2).toFixed(1));
      set('cine-fog-height', Math.round((p.fog.height ?? 0.3) * 100), (p.fog.height ?? 0.3).toFixed(2));
    }
    // [ENTERPRISE v8] LUT
    if (p.lut) {
      const lutSel = document.getElementById('cine-lut-mode');
      if (lutSel) lutSel.value = String(p.lut.mode || 0);
      set('cine-lut-intensity', Math.round((p.lut.intensity || 0) * 100), (p.lut.intensity || 0).toFixed(2));
    }
    // [ENTERPRISE v8] Bokeh
    if (p.bokeh) {
      const р = p.bokeh.enabled ? (p.bokeh.size ?? 0.5) : 0;   // [12.0.51] выключено — ноль
      set('cine-bokeh-size', Math.round(р * 100), р.toFixed(2));
      set('cine-bokeh-bright', Math.round((p.bokeh.bright ?? 2) / 5 * 500), (p.bokeh.bright ?? 2).toFixed(1));
    }
  } catch(e) { log.warn('[Cinematic] Sync sliders:', e.message); }
}

function getUserVRTPresets() {
  try { return JSON.parse(localStorage.getItem('vrt-user-presets') || '[]'); }
  catch(e) { log.debug('[Sidebar] getPresetKeys:', e.message); return []; }
}

function saveUserVRTPresets(presets) {
  try { localStorage.setItem('vrt-user-presets', JSON.stringify(presets)); } catch (e) { log.debug('[SidebarBindings]', e.message); }
}

function openVRTPresetManager() {
  const listEl = $('vrt-preset-list');
  const userListEl = $('vrt-user-preset-list');
  const countEl = $('vrt-preset-count');
  const currentEl = $('vrt-current-name');

  if (currentEl) currentEl.textContent = _activeVRTPreset || '—';

  // Встроенные
  if (listEl) {
    listEl.innerHTML = BUILTIN_VRT_PRESETS.map(p => `
      <div class="vrt-preset-item ${_activeVRTPreset === p.id ? 'active' : ''}" data-vrt-id="${p.id}">
        <span class="vrt-dot" style="background:${p.color}"></span>
        <span class="vrt-name">${p.name}</span>
      </div>`).join('');

    listEl.querySelectorAll('.vrt-preset-item').forEach(el => {
      el.onclick = () => {
        const id = el.dataset.vrtId;
        _activeVRTPreset = id;
        set3DPreset(id);
        // Обновляем UI
        listEl.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
        userListEl?.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
        el.classList.add('active');
        if (currentEl) currentEl.textContent = el.querySelector('.vrt-name')?.textContent || id;
        showToast(`🎨 ${el.querySelector('.vrt-name')?.textContent}`, 'info', 800);
      };
    });
  }

  // Пользовательские
  const userPresets = getUserVRTPresets();
  if (userListEl) {
    if (userPresets.length === 0) {
      userListEl.innerHTML = '<div style="padding:12px;text-align:center;color:var(--text-dim);font-size:11px;grid-column:1/-1;">Нет сохранённых пресетов</div>';
    } else {
      userListEl.innerHTML = userPresets.map((p, i) => `
        <div class="vrt-preset-item ${_activeVRTPreset === p.id ? 'active' : ''}" data-vrt-user-idx="${i}">
          <span class="vrt-dot" style="background:${p.color || '#888'}"></span>
          <span class="vrt-name">${p.name}</span>
          <span class="vrt-del" data-vrt-del="${i}" title="Удалить">✕</span>
        </div>`).join('');

      userListEl.querySelectorAll('.vrt-preset-item').forEach(el => {
        el.onclick = (e) => {
          if (e.target.classList.contains('vrt-del')) return;
          const idx = parseInt(el.dataset.vrtUserIdx);
          const p = userPresets[idx];
          if (!p) return;
          _activeVRTPreset = p.id;
          // Применяем сохранённые WW/WC + 3D preset
          if (p.cs3dPreset) set3DPreset(p.cs3dPreset);
          // Здесь ww/wc — самостоятельная часть пользовательского пресета,
          // а не довесок к объёмному: её место действительно на срезах.
          if (p.ww && p.wc) applyWindowToSlices({ ww: p.ww, wc: p.wc });
          listEl?.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
          userListEl.querySelectorAll('.vrt-preset-item').forEach(e => e.classList.remove('active'));
          el.classList.add('active');
          if (currentEl) currentEl.textContent = p.name;
          showToast(`🎨 ${p.name}`, 'info', 800);
        };
      });

      // Delete buttons
      userListEl.querySelectorAll('.vrt-del').forEach(btn => {
        btn.onclick = (e) => {
          e.stopPropagation();
          const idx = parseInt(btn.dataset.vrtDel);
          if (!confirm(`Удалить пресет "${userPresets[idx]?.name}"?`)) return;
          userPresets.splice(idx, 1);
          saveUserVRTPresets(userPresets);
          openVRTPresetManager(); // Обновляем
          showToast('🗑️ Пресет удалён', 'info');
        };
      });
    }
  }

  if (countEl) countEl.textContent = `${BUILTIN_VRT_PRESETS.length} + ${userPresets.length} польз.`;

  // Save form
  const saveBtn = $('vrt-btn-save-current');
  const saveForm = $('vrt-save-form');
  const doSaveBtn = $('vrt-btn-do-save');
  const cancelSaveBtn = $('vrt-btn-cancel-save');

  if (saveBtn) saveBtn.onclick = () => { if (saveForm) saveForm.style.display = ''; };
  if (cancelSaveBtn) cancelSaveBtn.onclick = () => { if (saveForm) saveForm.style.display = 'none'; };
  if (doSaveBtn) doSaveBtn.onclick = () => {
    const nameInput = $('vrt-new-name');
    const colorInput = $('vrt-new-color');
    const name = nameInput?.value?.trim();
    if (!name) { showToast('⚠️ Введите название', 'warning'); return; }

    // Считываем текущие WW/WC из viewport
    const re = getRenderingEngine();
    const vp = re?.getViewport(_ctx.getCurrentViewportId());
    let ww = 400, wc = 40;
    try {
      const voiRange = vp?.getProperties?.()?.voiRange;
      if (voiRange) {
        ww = Math.round(voiRange.upper - voiRange.lower);
        wc = Math.round((voiRange.upper + voiRange.lower) / 2);
      }
    } catch (e) { log.debug('[SidebarBindings]', e.message); }

    const newPreset = {
      id: 'user_' + Date.now(),
      name: name,
      color: colorInput?.value || '#888',
      cs3dPreset: _activeVRTPreset || '',
      ww, wc,
      created: new Date().toISOString()
    };

    const presets = getUserVRTPresets();
    presets.push(newPreset);
    saveUserVRTPresets(presets);
    if (saveForm) saveForm.style.display = 'none';
    if (nameInput) nameInput.value = '';
    openVRTPresetManager();
    showToast(`💾 Пресет "${name}" сохранён`, 'success');
  };

  // Export / Import
  const exportBtn = $('vrt-btn-export');
  if (exportBtn) exportBtn.onclick = () => {
    const data = JSON.stringify(getUserVRTPresets(), null, 2);
    const blob = new Blob([data], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'vrt-presets.json';
    a.click();
    showToast('📤 Экспортировано', 'success');
  };

  const importBtn = $('vrt-btn-import');
  if (importBtn) importBtn.onclick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = async () => {
      try {
        const text = await input.files[0].text();
        const imported = JSON.parse(text);
        if (!Array.isArray(imported)) throw new Error('Invalid format');
        const existing = getUserVRTPresets();
        const merged = [...existing, ...imported.map(p => ({ ...p, id: 'user_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6) }))];
        saveUserVRTPresets(merged);
        openVRTPresetManager();
        showToast(`📥 Импортировано ${imported.length} пресетов`, 'success');
      } catch(e) {
        showToast('❌ Ошибка импорта: ' + e.message, 'error');
      }
    };
    input.click();
  };
}

// ============================================================
// W/L PRESETS
// ============================================================
// ============================================================
// W/L PRESETS
// ============================================================
/**
 * [11.1.17] Оба грида — правая панель и мобильный ящик — рендерятся из
 * ЕДИНОГО каталога core/wlChips.js. Две рукописные копии разъехались
 * (аудит §2.2: в мобильном пропали Средостение, Височная кость, Таз, PET,
 * US, рентген-Кости/Мягк. и «Ангио (кино)» с авто-окном); теперь дрейф
 * невозможен по построению, а «Ангио (кино)» впервые доступно с телефона.
 */
function построитьЧипыОкон() {
  for (const г of ГРУППЫ_ЧИПОВ) {
    for (const суффикс of ['', '-m']) {
      const узел = $('wl-grid-' + г.ключ + суффикс);
      if (узел) узел.innerHTML = г.чипы.map(chipHtml).join('');
    }
  }
}

function bindPresetChips() {
  // [12.0.49] Окно, сменённое быстрой клавишей или голосом, — как окно чипа:
  // надпись W/L на снимке и подсветка чипов с теми же числами. Ползунки ручного
  // W/L подхватывают его отдельно (bindCustomWL, то же событие). Окно по кадру
  // (клавиша A) ни с одним чипом не совпадает — подсветка снимается.
  document.addEventListener('mikhmel:окно-извне', (e) => {
    const д = e.detail;
    if (!д || !Number.isFinite(д.ww) || !Number.isFinite(д.wc)) return;
    updateWLOverlay(д.ww, д.wc);
    if (д.авто) подсветитьЧипыОкна(NaN, NaN); else подсветитьЧипыОкна(д.ww, д.wc);
  }, { signal: _ac.signal });
  // [11.1.17] Обработчик ОДИН на оба сорта чипов. Раньше их было два
  // независимых onAll ([data-ww] и [data-wl-auto]); чип, несущий оба атрибута
  // (МРТ: авто + затравка), стрелял бы дважды — та же порода, что двойной
  // «Снимок экрана» из 11.1.16. Ветвление внутри одного слушателя закрывает
  // ловушку по построению.
  const отметить = (чип) => {
    $$('.preset-chip[data-ww], .preset-chip[data-wl-auto]').forEach((c) => {
      c.classList.remove('active');
      c.setAttribute('aria-pressed', 'false');   // [11.1.17] аудит §2.5
    });
    чип.classList.add('active');
    чип.setAttribute('aria-pressed', 'true');
  };

  onAll('.preset-chip[data-ww], .preset-chip[data-wl-auto]', 'click', async (e) => {
    const чип = e.currentTarget;   // до await: после него currentTarget пуст
    if (чип.dataset.wlAuto) {
      // [10.3.2] Окно не табличное — по 1–99 перцентилю яркости кадра.
      // [12.0.49] Каждой серии — своё: T1 и DWI рядом в 2×2 получают каждая
      // окно по своему кадру (core/wlApply.js), плоскости одного объёма — одно.
      const р = applyAutoWindowToSlices();
      const w = р.окноАктивного;
      if (w) {
        отметить(чип);
        updateWLOverlay(w.ww, w.wc);
        showToast(`${чип.textContent} (авто по кадру): W:${w.ww} L:${w.wc}${р.серий > 1 ? ` · у каждой из ${р.серий} серий своё окно` : ''}`, 'success', 1800);
        return;
      }
      // [11.1.17] Затравка (аудит §2.3): у МРТ-чипов есть типовые числа —
      // применяем их С ОГОВОРКОЙ, пока кадр не готов. У XA затравки нет
      // нарочно (типовых чисел у съёмки с С-дуги не существует) — прежний
      // честный отказ. [12.0.49] То же у маммографии и ПЭТ.
      const ww = parseInt(чип.dataset.ww), wc = parseInt(чип.dataset.wc);
      if (Number.isFinite(ww) && Number.isFinite(wc)) {
        applyWindowToSlices({ ww, wc });
        отметить(чип);
        updateWLOverlay(ww, wc);
        showToast(`Кадр не готов — применены типовые ${чип.textContent}: W:${ww} L:${wc}. Нажмите ещё раз для авто-окна`, 'warning', 3000);
      } else {
        showToast('Кадр ещё не загружен — подождите секунду и нажмите снова', 'warning', 2500);
      }
      return;
    }
    const ww = parseInt(чип.dataset.ww);
    const wc = parseInt(чип.dataset.wc);
    // Окно плотности — на срезовые окна. Это самостоятельный пресет окна,
    // а не довесок к объёмному, и адресат у него именно срезы.
    applyWindowToSlices({ ww, wc });
    отметить(чип);
    updateWLOverlay(ww, wc);
    showToast(`W:${ww} L:${wc}`, 'info', 1000);
  });
}

/**
 * Ручной W/L: ЖИВОЙ предпросмотр и сброс. [10.19.28]
 *
 * Было: ползунок менял только цифру рядом, картинка ждала «Применить» — врач
 * крутил вслепую. Кнопки возврата не было вовсе, ни для чисел, ни для
 * изображения. Слова владельца: «двигаю бегунок и ничего не происходит… нет
 * кнопки сбросить для возврата не только цифр, но и самого изображения».
 *
 * Стало: правка применяется НА ХОДУ, не чаще раза в кадр (правило и его
 * проверка — core/wlManual.js: последнее значение доходит всегда, иначе
 * картинка застывала бы на предпоследнем положении пальца). «Сброс»
 * возвращает окно, которое было ДО правки — то есть выбранный пресет, а не
 * абстрактные 400/40.
 *
 * Применяется ВО ВСЕ СРЕЗЫ (applyWindowToSlices) — по решению владельца и ради
 * единообразия: чипы-пресеты выше по панели делают ровно это, и ползунок,
 * бивший в одно окно, вёл себя иначе, чем соседи.
 * [12.0.49] «Во все» уточнено: в выбранное окно и в окна той же модальности
 * (core/wlApply.js) — КТ-окно больше не ложится на ПЭТ рядом. Правило одно
 * для чипов, ползунков, сценариев, быстрых клавиш и голоса.
 *
 * Ползунков ДВЕ ПАРЫ: сайдбарная (custom-ww/custom-wc) и мобильная
 * (custom-ww-m/custom-wc-m, связана через data-sync). Чинятся как одна: иначе
 * на телефоне ползунок остался бы мёртвым — там та же панель, только в ящике.
 */
/**
 * [11.1.63] Записать число туда, где оно показывается: в поле ввода — .value,
 * в подпись — .textContent. Пока человек печатает в этом поле, НЕ трогаем его:
 * иначе ползунок перебивал бы набираемые цифры на полуслове.
 */
function _записатьЧисло(эл, число) {
  if (!эл) return;
  if (эл.tagName === 'INPUT') {
    if (document.activeElement === эл) return;
    if (String(эл.value) !== String(число)) эл.value = число;
  } else if (эл.textContent !== String(число)) {
    эл.textContent = число;
  }
}

/** Прочитать число из поля или подписи. NaN, если там не число. */
function _прочитатьЧисло(эл) {
  if (!эл) return NaN;
  const т = (эл.tagName === 'INPUT' ? эл.value : эл.textContent) ?? '';
  const с = String(т).trim().replace(',', '.');
  return с === '' ? NaN : Number(с);
}

function bindCustomWL() {
  const пары = [
    { ww: $('custom-ww'), wc: $('custom-wc') },
    { ww: $('custom-ww-m'), wc: $('custom-wc-m') },
  ].filter((п) => п.ww && п.wc);
  if (!пары.length) return;

  // [11.1.17] Шкала — из максимумов каталога чипов, а не из чисел разметки:
  // зашитые max 8000/4000 не вмещали собственный чип PET 30000/15000, при
  // том что wlmanual_test прямо пиннит «у ПЭТ — тысячи» (аудит §2.1).
  const пределы = пределыШкалы();
  for (const п of пары) {
    п.ww.max = Math.max(Number(п.ww.max) || 0, пределы.wwMax);
    п.wc.max = Math.max(Number(п.wc.max) || 0, пределы.wcMax);
    п.wc.min = Math.min(Number(п.wc.min) || 0, пределы.wcMin);
  }

  const подписи = () => [$('custom-ww-val'), $('custom-wc-val')];
  // [12.0.49] Вторая пара полей — в мобильном ящике (custom-ww-val-m,
  // custom-wc-val-m). Раньше там стояли подписи-span, и ввести число с
  // телефона было нельзя. Числа пишутся в обе пары; ввод читается из той
  // пары, где печатали.
  const всеПоля = () => [подписи(), [$('custom-ww-val-m'), $('custom-wc-val-m')]].filter(([a, b]) => a && b);
  const параПоля = (поле) => всеПоля().find((п) => п.includes(поле)) || подписи();
  const память = памятьОкна();

  const окноНаЭкране = () => {
    try {
      const re = getRenderingEngine?.();
      const vp = re?.getViewport?.(_ctx.getCurrentViewportId());
      const r = vp?.getProperties?.()?.voiRange;
      if (!r || !Number.isFinite(r.lower) || !Number.isFinite(r.upper)) return null;
      return зажать({ ww: r.upper - r.lower, wc: (r.upper + r.lower) / 2 });
    } catch (e) { return null; }
  };

  const показатьЧисла = (ww, wc) => {
    for (const п of пары) {
      // [11.1.17] Сначала растянуть шкалу, потом писать: иначе браузер молча
      // зажимает value к max, и подпись расходится с бегунком (аудит §2.1).
      подстроитьШкалу(п.ww, ww); подстроитьШкалу(п.wc, wc);
      if (String(п.ww.value) !== String(ww)) п.ww.value = ww;
      if (String(п.wc.value) !== String(wc)) п.wc.value = wc;
      for (const эл of [п.ww, п.wc]) {
        const рядом = эл.parentElement?.querySelector('.ctrl-value');
        if (рядом && !рядом.id) рядом.textContent = эл.value;
      }
    }
    // [11.1.63] Числа справа стали ПОЛЯМИ ВВОДА (владелец: «бегунок очень
    // жёсткий, им не выбрать необходимые цифры»). Поле пишется через .value,
    // подпись — через .textContent. Одна мера на оба случая, чтобы не
    // разъехалось: если поле окажется снова span-ом, писать будем правильно.
    // [12.0.49] Обе пары: правая панель и мобильный ящик.
    for (const [вWW, вWC] of всеПоля()) {
      _записатьЧисло(вWW, ww);
      _записатьЧисло(вWC, wc);
    }
  };

  const применить = ({ ww, wc }) => {
    applyWindowToSlices({ ww, wc });
    updateWLOverlay(ww, wc);
  };
  const огр = поКадрам(применить);

  const наДвижение = (п) => {
    const з = зажать({ ww: п.ww.value, wc: п.wc.value });
    if (!з.годно) return;
    // Точка возврата — то, что показано на экране ДО первого движения, а не
    // положение ползунка: ползунок мог остаться от прошлой серии.
    память.началПравку(окноНаЭкране() || з);
    показатьЧисла(з.ww, з.wc);
    огр.подать({ ww: з.ww, wc: з.wc });
    // Ползунок ведёт сам себя: чипы-пресеты больше не выглядят выбранными.
    $$('.preset-chip[data-ww], .preset-chip[data-wl-auto]').forEach((c) => { c.classList.remove('active'); c.setAttribute('aria-pressed', 'false'); });
  };

  for (const п of пары) {
    п.ww.addEventListener('input', () => наДвижение(п), { signal: _ac.signal });
    п.wc.addEventListener('input', () => наДвижение(п), { signal: _ac.signal });
  }

  // [11.1.63] ВВОД ЧИСЛОМ. Применяем по Enter и по уходу из поля, а НЕ на
  // каждую нажатую цифру: пока человек печатает «160», промежуточные «1» и
  // «16» перерисовывали бы всё исследование дважды впустую, а «-» в уровне
  // вообще не число.
  //
  // Ползунок при этом подтягивается к введённому — иначе следующее его
  // движение прыгнуло бы от старого положения.
  const наВвод = (e) => {
    const [вWW, вWC] = параПоля(e?.target);
    const з = зажать({ ww: _прочитатьЧисло(вWW), wc: _прочитатьЧисло(вWC) });
    if (!з.годно) {
      // Не молчим и не подставляем своё: возвращаем то, что на экране.
      const было = окноНаЭкране();
      if (было?.годно) показатьЧисла(было.ww, было.wc);
      showToast('Введите числа: окно — целое от 1, уровень — целое (у КТ бывает отрицательным)', 'warning', 4000);
      return;
    }
    память.началПравку(окноНаЭкране() || з);
    огр.сброситьОжидание();
    применить(з);
    показатьЧисла(з.ww, з.wc);
    $$('.preset-chip[data-ww], .preset-chip[data-wl-auto]').forEach((c) => { c.classList.remove('active'); c.setAttribute('aria-pressed', 'false'); });
    showToast(`Окно: W:${з.ww} L:${з.wc}`, 'success', 1200);
  };
  for (const поле of всеПоля().flat()) {
    if (!поле || поле.tagName !== 'INPUT') continue;
    поле.addEventListener('change', наВвод, { signal: _ac.signal });
    поле.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); наВвод(e); поле.blur(); }
    }, { signal: _ac.signal });
    // Щелчок по полю не должен уезжать в инструменты окна просмотра.
    поле.addEventListener('pointerdown', (e) => e.stopPropagation(), { signal: _ac.signal });
  }

  // «Применить» остаётся: она фиксирует явно и нужна тем, кто ждёт нажатия.
  on('btn-apply-custom-wl', 'click', () => {
    const з = зажать({ ww: пары[0].ww.value, wc: пары[0].wc.value });
    if (!з.годно) return;
    память.началПравку(з);
    применить(з);
    // [12.0.48] Чипы горят по числам, как при открытии серии: введено 400/40 —
    // горят «Живот», «Грудная кл.», «Таз»; иное окно — не горит ни один (прежде
    // после «Применить» оставался гореть чип прежнего окна).
    подсветитьЧипыОкна(з.ww, з.wc);
    showToast(`Окно: W:${з.ww} L:${з.wc}`, 'success', 1200);
  });

  on('btn-reset-custom-wl', 'click', () => {
    const в = память.дляСброса();
    if (!в.есть) { showToast(в.причина, 'info', 2500); return; }
    огр.сброситьОжидание();
    применить(в.окно);
    показатьЧисла(в.окно.ww, в.окно.wc);
    память.сброшено();
    showToast(`Возврат к W:${в.окно.ww} L:${в.окно.wc}`, 'info', 1800);
  });

  // Окно, пришедшее ИЗВНЕ, становится новой точкой возврата — иначе «Сброс»
  // уводил бы к позапрошлому состоянию. Отдельного события смены окна в
  // программе нет (проверял), поэтому берём то, что ДЕЙСТВИТЕЛЬНО показано:
  // voiRange живого окна. Это надёжнее любого события — оно описывает картинку
  // на экране, а не намерение того, кто окно менял.
  // Чип-пресет и всё прочее, что меняет окно мимо ползунка: после их работы
  // запоминаем показанное как новую точку возврата.
  const подхватитьИзвне = () => {
    const з = окноНаЭкране();
    if (з?.годно) { память.запомнитьИзвне(з); показатьЧисла(з.ww, з.wc); }
  };
  document.addEventListener('click', (e) => {
    if (e.target?.closest?.('.preset-chip[data-ww], .preset-chip[data-wl-auto]')) {
      setTimeout(подхватитьИзвне, 0);   // после того, как пресет применён
    }
  }, { signal: _ac.signal });
  // [12.0.48] Сценарий КТ тоже меняет окно мимо ползунка — подхватываем.
  document.addEventListener('mikhmel:окно-извне', () => setTimeout(подхватитьИзвне, 0), { signal: _ac.signal });
}

// ============================================================
// RIGHT TABS
// ============================================================
function bindRightTabs() {
  onAll('.right-tab[data-tab]', 'click', (e) => {
    const tabId = e.currentTarget.dataset.tab;
    // [11.1.16] aria-selected раньше был мёртвым: разметка ставила true
    // «Пресетам» навсегда, обработчик переключал только классы — скринридер
    // объявлял выбранными «Пресеты», даже когда открыты «Отчёты». Теперь
    // атрибут ходит вместе с классом. (aria-expanded раскрывашки жив и был —
    // htmlInit.js; аудит 11.1.15 на его счёт ошибался.)
    $$('.right-tab').forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
    $$('.tab-panel').forEach(p => p.classList.remove('active'));
    e.currentTarget.classList.add('active');
    e.currentTarget.setAttribute('aria-selected', 'true');
    const panel = $(tabId);
    if (panel) panel.classList.add('active');
  });
}

// ============================================================
// PANEL COLLAPSES
// ============================================================
function bindPanelCollapses() {
  onAll('.panel-header[data-panel]', 'click', (e) => {
    const panelId = e.currentTarget.dataset.panel;
    const body = $(panelId);
    if (!body) return;
    body.classList.toggle('collapsed');
    const toggle = e.currentTarget.querySelector('.toggle');
    if (toggle) toggle.textContent = body.classList.contains('collapsed') ? '▸' : '▾';
  });
}

// ============================================================
// MODALS
// ============================================================
function bindModals() {
  // [FIX] Ловим ВСЕ элементы с data-close (не только .modal-close)
  onAll('[data-close]', 'click', (e) => closeModal(e.currentTarget.dataset.close));
  onAll('.modal-overlay', 'click', (e) => { if (e.target === e.currentTarget) e.target.classList.remove('open'); });
}

// [10.0.3] Модальные окна ведёт ModalManager: ловушка фокуса, Esc, клик по
// подложке, стопка открытых окон. Здесь было просто добавление и снятие
// класса — работало, но с клавиатуры окно было непроходимо: Tab уходил на
// страницу за окном, Esc не закрывал вовсе.
function openModal(id) { ModalManager.open(id); }
function closeModal(id) { ModalManager.close(id); }

// ============================================================
// SIDEBAR TOGGLES
// ============================================================
function bindSidebarToggles() {
  on('btn-sidebar-left-toggle', 'click', () => {
    const el = $('sidebar-left');
    if (el) el.style.display = el.style.display === 'none' ? '' : 'none';
  });
  on('btn-sidebar-right-toggle', 'click', () => {
    const el = $('sidebar-right');
    if (el) el.style.display = el.style.display === 'none' ? '' : 'none';
  });
}

// ============================================================
// ALL SLIDERS — auto-update value displays
// ============================================================
let _последнийVRTПресет = null;   // [11.1.23] что пере-применять при смене «Плотности тканей»

/** [11.1.24] «Вернуть тело» после изоляции органа пере-применяет этот пресет. */
export function получитьПоследнийVRTПресет() { return _последнийVRTПресет; }

function bindSliderUpdates() {
  const pairs = [
    ['brush-size', 'brush-size-val', null],
    ['seg-opacity', 'seg-opacity-val', v => v + '%'],
    // [12.0.54] Радиус доводки маски: подпись стояла «2» при любом положении
    // ползунка — операции брали новое число, а врач видел старое.
    ['mask-clean-radius', 'mask-clean-radius-val', null],
    // [12.0.56] пара nodule-thresh убрана вместе с карточкой «Узлы лёгких» (вкладка ИИ).
    // [11.0.2] ПОДКЛЮЧЕНЫ (решение владельца). Раньше оба меняли только
    // подпись рядом с собой, и «Объём 3D» был разделом из двух вывесок.
    ['vrt-opacity-scale', 'vrt-opacity-scale-val', v => v + '%'],   // [11.1.23]
    ['vrt-opacity-scale-m', 'vrt-opacity-scale-m-val', v => v + '%'],   // [11.1.26] мобильный двойник
    ['vrt-crop-level-m', 'vrt-crop-level-m-val', v => v + '%'],
    ['vrt-crop-front-level', 'vrt-crop-front-level-val', v => v + '%'],       // [12.0.31] передняя стенка
    ['vrt-crop-front-level-m', 'vrt-crop-front-level-m-val', v => v + '%'],
    ['vrt-soft-scale', 'vrt-soft-scale-val', v => v + '%'],      // [11.1.47] мягкие ткани
    ['vrt-soft-thr', 'vrt-soft-thr-val', v => v + ' HU'],
    ['vrt-win-depth', 'vrt-win-depth-val', v => v + '%'],       // [11.1.46] окно обзора
    ['vrt-win-size', 'vrt-win-size-val', v => v + '%'],
    ['vrt-win-x', 'vrt-win-x-val', v => String(v)],
    ['vrt-win-z', 'vrt-win-z-val', v => String(v)],         // [11.1.35] «Убрать стол» на телефоне

    ['vol-iso', 'vol-iso-val', null],
    ['vol-opacity', 'vol-opacity-val', v => v + '%'],
    // [10.19.30] пара fusion-opacity убрана: ползунка нет в разметке с тех же
    // времён, что и его кнопок-призраков (см. featureBindings). Живой ползунок
    // прозрачности — ds-fusion-opacity, его ведёт proFeaturesBindings.
    ['cine-fps-tab', 'cine-fps-tab-val', null],
    ['cine-fps', 'cine-fps-val', null],
    ['mc-iso', 'mc-iso-val', null],
    ['thresh-low', 'thresh-low-val', null],
    ['thresh-high', 'thresh-high-val', null],
    ['ann-line-width', 'ann-line-width-val', null],
    ['ann-font-size', 'ann-font-size-val', null],
    ['endo-position', 'endo-pos-val', v => v + '%'],
    ['endo-fov', 'endo-fov-val', v => v + '°'],
    // [11.0.2] пара slab-thickness убрана вместе с разделом «Слэб / Толщина»:
    // ползунка нет в разметке, а подпись была всей его работой.
    // [10.19.11] Три ползунка наклона (oblique-x/y/z) убраны ОТСЮДА намеренно.
    // Здесь они только обновляли подпись — камера не поворачивалась, то есть
    // косых реформатов не было вовсе. Теперь их ведёт ui/obliqueBindings.js:
    // он и подпись меняет, и ориентацию окна применяет.
    ['dsa-gain', 'dsa-gain-val', v => parseFloat(v).toFixed(1)],
    ['clip-x', 'clip-x-val', v => v + '%'],
    ['clip-y', 'clip-y-val', v => v + '%'],
    ['clip-z', 'clip-z-val', v => v + '%'],
    ['region-grow-range', 'region-grow-range-val', v => '±' + v],
  ];
  pairs.forEach(([sliderId, valId, fmt]) => {
    const slider = $(sliderId), val = $(valId);
    if (slider && val) slider.addEventListener('input', () => { val.textContent = fmt ? fmt(slider.value) : slider.value; }, { signal: _ac.signal });
  });
  // Color picker
  // [11.1.21] Провод от «Стиля аннотаций» к движку — раздел был вывеской
  // (аудит §1.3): цвет красил подпись, линии оставались зелёными. Цвет
  // применяется живо, толщина и шрифт — по отпусканию; при недоступном
  // движке говорим один раз, а не молчим.
  let _стильПредупредил = false;
  const _применитьСтиль = (н) => {
    if (setAnnotationStyle(н)) return;
    if (!_стильПредупредил) {
      _стильПредупредил = true;
      showToast('Стиль аннотаций применится после загрузки исследования', 'info', 2500);
    }
  };
  // [11.1.23] «Плотность тканей»: масштаб задаётся движку пресетов, затем
  // активный пресет применяется заново — иначе новая кривая легла бы только
  // при следующем ручном выборе. По отпусканию, не живьём: каждое применение
  // пересобирает передаточные функции объёма.
  // [11.1.25] «Плотность тканей» действует СРАЗУ (замечание владельца:
  // «почему реагирует только на следующий пресет?»). Причина была в том,
  // что пере-применить пресет мог лишь тот, кто помнил ВЫБОР ВРАЧА, — а
  // пресет часто ставится при загрузке, профилем или из другой панели, и
  // тогда помнить было нечего. Теперь движок пресетов сам держит последнюю
  // кривую и пересчитывает её на живом объёме; нам остаётся перерисовать.
  // Слушаем 'input' (тянем ползунок — картинка меняется), перерисовку
  // прижимаем к кадру, чтобы не звать рендер на каждый пиксель движения.
  let _плотностьЖдёт = false;
  // [11.1.36] Мобильный двойник подключён НАПРЯМУЮ к тому же хозяину, а не
  // через цепочку data-sync-input → синтетическое событие → делегирование на
  // document (mobileBindings). Та цепочка ни разу не жила на настоящем
  // телефоне (двойник до 11.1.35 был недостижим), и владелец получил
  // «движется, но ничего не делает». Двойник зеркалит значение в настоящий
  // ползунок и будит его событием — хозяин один, путь короткий и видимый.
  on('vrt-opacity-scale-m', 'input', (e) => {
    const наст = $('vrt-opacity-scale');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('input', { bubbles: false }));
  });
  on('vrt-opacity-scale-m', 'change', (e) => {
    const наст = $('vrt-opacity-scale');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('change', { bubbles: false }));
  });
  // [11.1.47] Мягкие ткани отдельно от органов. Хозяин один — этот блок.
  let _мягкиеЖдут = false;
  const _мягкие = () => {
    const коэф = (Number($('vrt-soft-scale')?.value) || 100) / 100;
    const порог = Number($('vrt-soft-thr')?.value) || 70;
    // [11.1.47] Импорт СТАТИЧЕСКИЙ, как у setGlobalOpacityScale строкой 33.
    try {
      const легло = setSoftTissueScale(коэф, порог);
      if (!легло) {
        if (коэф < 1) showToast('Гасить нечего: объёмная картинка ещё не построена', 'info', 2500);
        return;
      }
      // [11.1.47.1] ПЕРЕРИСОВКА — вот чего не хватало. Владелец: «ползунки
      // совсем не реагируют, даже в крайних положениях». И были правы:
      // setSoftTissueScale честно менял функцию непрозрачности, но НИКТО не
      // просил окна перерисоваться — экран показывал прежний кадр до
      // следующего касания мыши. У соседней «Плотности тканей» перерисовка
      // стоит сразу за расчётом (строки выше), а я её не повторил. Тот же
      // приём: один кадр на requestAnimationFrame, чтобы не рвать таскание.
      if (_мягкиеЖдут) return;
      _мягкиеЖдут = true;
      requestAnimationFrame(() => {
        _мягкиеЖдут = false;
        try {
          const re = getRenderingEngine();
          re?.renderViewports?.(re.getViewports().map((v) => v.id));
        } catch (err) { log.debug('[Мягкие ткани] перерисовка:', err.message); }
      });
    } catch (e) { showToast('Мягкие ткани: ' + e.message, 'warning', 3000); }
  };
  // По отпусканию — словами, как у «Плотности тканей».
  const _мягкиеСловами = () => {
    const проценты = Number($('vrt-soft-scale')?.value) || 100;
    const порог = Number($('vrt-soft-thr')?.value) || 70;
    showToast(проценты >= 100
      ? 'Мягкие ткани: без гашения (100%)'
      : `Мягкие ткани: ${проценты}% ниже ${порог} HU — органы и сосуды не тронуты`,
      'info', 1600);
  };
  on('vrt-soft-scale', 'input', _мягкие);
  on('vrt-soft-thr', 'input', _мягкие);
  on('vrt-soft-scale', 'change', _мягкиеСловами);
  on('vrt-soft-thr', 'change', _мягкиеСловами);

  on('vrt-opacity-scale', 'input', (e) => {
    const проценты = Number(e.target.value) || 100;
    const легло = setGlobalOpacityScale(проценты / 100);
    if (!легло) return;   // объёма ещё нет — ляжет с ближайшим пресетом
    if (_плотностьЖдёт) return;
    _плотностьЖдёт = true;
    requestAnimationFrame(() => {
      _плотностьЖдёт = false;
      try {
        const re = getRenderingEngine();
        re?.renderViewports?.(re.getViewports().map((v) => v.id));
      } catch (err) { log.debug('[Плотность тканей] перерисовка:', err.message); }
    });
  });
  // По отпусканию — словами: подтверждение или честное «ещё нет объёма».
  on('vrt-opacity-scale', 'change', (e) => {
    const проценты = Number(e.target.value) || 100;
    const легло = setGlobalOpacityScale(проценты / 100);
    showToast(легло
      ? `Плотность тканей: ${проценты}%`
      : `Плотность тканей: ${проценты}% — применится, как только появится объёмная картинка`,
      'info', легло ? 1200 : 2600);
  });

  // ══ [11.1.26] «УБРАТЬ СТОЛ» ══
  // Дека — те же 100–700 HU, что кость: пресетом не отделить, отделяем
  // геометрией. Плоскость отсечения режет ПОКАЗ, не данные; выключатель и
  // ползунок возвращают всё как было.
  /**
   * [11.1.34] Ищем объёмного актёра ЦЕПКО и по стадиям, чтобы отказ называл
   * настоящую причину. Прошлая редакция сдавалась на первом же null и
   * говорила «нет объёмного окна» даже тогда, когда окно есть, а объём в
   * него ещё не подан, — и переключатель при этом не двигался вовсе
   * (замечание владельца: «не перемещается вправо»).
   * @returns {{стадия:'нет-окна'|'окно-пустое'|'нет-маппера'|'готово', vp?, актёр?, mapper?}}
   */
  /**
   * [11.1.36] Собираем ВСЕ объёмные окна, а не первое попавшееся. Первое
   * попавшееся и было ямой: плоскость ложилась в окно режима «3D», а
   * «3D пресет» — это ДРУГОЕ окно (шестое, MPR6, во весь экран), и в нём
   * стол оставался при сдвинутом тумблере (замечание владельца, скриншоты).
   * Возвращает список готовых {vp, mapper, актёр} и сводную стадию отказа.
   */
  const _актёрыОбъёма = () => {
    const готовые = [];
    const стадии = new Set();
    try {
      const re = getRenderingEngine();
      const окна = re?.getViewports?.() || [];
      for (const vp of окна) {
        const т = String(vp?.type || '').toLowerCase();
        const объёмное = т.includes('volume3d') || т === 'volume_3d' || т.includes('3d')
          || String(vp?.id || '').toLowerCase().includes('3d');
        if (!объёмное) continue;
        // Актёр достаётся двумя путями: getDefaultActor есть не во всех
        // сборках Cornerstone (оговорка уже записана в viewport.js 6.7.33).
        const актёр = vp.getDefaultActor?.()?.actor
          || vp.getActors?.()?.[0]?.actor
          || vp.getActors?.()?.[0]?.volumeActor
          || null;
        if (!актёр) { стадии.add('окно-пустое'); continue; }
        const mapper = актёр.getMapper?.() || null;
        if (!маперПоддерживает(mapper)) { стадии.add('нет-маппера'); continue; }
        готовые.push({ vp, актёр, mapper });
      }
    } catch (e) {
      log.debug('[Убрать стол] поиск актёров:', e.message);
    }
    const стадия = готовые.length ? 'готово'
      : (стадии.has('окно-пустое') ? 'окно-пустое'
        : (стадии.has('нет-маппера') ? 'нет-маппера' : 'нет-окна'));
    return { стадия, готовые };
  };

  const _причина = (стадия) => ({
    'нет-окна': 'Нет объёмного окна: включите раскладку с 3D (например, MPR+3D)',
    'окно-пустое': 'Объёмное окно есть, но объём в него ещё не подан — дождитесь загрузки и повторите',
    'нет-маппера': 'Этот режим рендера не поддерживает плоскости отсечения (кинематический — не поддерживает; переключитесь на обычный объём)',
  })[стадия] || 'Не удалось отсечь стол';

  // [12.0.31] Что включено — читается с тумблеров: у отсечения теперь две
  // стороны, и выключение одной не должно снимать другую.
  const _вкл = (id) => !!$(id)?.classList.contains('on');
  const _применитьОтсечение = async (включено) => {
    включено = !!включено && (_вкл('vrt-crop-table') || _вкл('vrt-crop-front') || _вкл('vrt-window-box'));
    const о = _актёрыОбъёма();
    if (о.стадия !== 'готово') return { ок: false, стадия: о.стадия, причина: _причина(о.стадия) };
    try {
      const доля = (Number($('vrt-crop-level')?.value) || 12) / 100;
      const vtkPlane = включено ? await getVtkPlaneClass() : null;
      if (включено && !vtkPlane?.newInstance) {
        return { ок: false, стадия: 'нет-маппера', причина: 'Плоскости отсечения недоступны в этой сборке' };
      }
      let легло = 0;
      const имена = [];
      let сеченийСнято = false;   // [12.0.57]
      for (const { vp, актёр, mapper } of о.готовые) {
        try {
          // [12.0.57] Сечения осей X/Y/Z со вкладки «Спец. режимы» — чужие:
          // прежде removeAllClippingPlanes сносил и их (тумблер стола снимал
          // сечение по X, а сечение по X — стол). Снимаем всё, своё кладём
          // заново, чужое — обратно следом, и вместе не больше шести.
          const оси = плоскостиОсейНаМаппере(mapper);
          mapper.removeAllClippingPlanes();
          запомнитьПлоскости(mapper, []);   // [12.0.51] снятое — не стеречь
          if (включено) {
            // [11.1.46] Плоскостей может быть НЕСКОЛЬКО: одна для среза
            // (спина или перед) плюс шесть для окна обзора. Маппер их
            // пересекает — это и даёт коробку.
            const b = актёр.getBounds?.() || [];
            const список = [];
            const окноВкл = $('vrt-window-box')?.classList.contains('on');
            // [11.1.49] ШЕСТЬ — ПРЕДЕЛ, И ОН ЖЁСТКИЙ. Шейдер объёмного маппера
            // vtk.js держит РОВНО шесть плоскостей отсечения (сверено с
            // Rendering/OpenGL/VolumeMapper.js: vClipPlaneNormals[6]). Мы же
            // при включённом окне слали семь — срез плюс шесть граней
            // коробки, — и рендер срывался в пустоту: у владельца исчезали
            // оба объёмных окна целиком.
            //
            // Поэтому при включённом окне срез НЕ добавляется: передняя
            // грань коробки и так режет спереди, а «Убрать стол» заменяется
            // задней гранью. Ровно шесть.
            if (!окноВкл) {
              // [12.0.31] Обе стороны сразу, каждая со своей долей: стол
              // сзади и передняя стенка спереди — 0–2 плоскости.
              список.push(...плоскостиСторон(b, {
                стол: _вкл('vrt-crop-table') ? доля : null,
                перед: _вкл('vrt-crop-front') ? (Number($('vrt-crop-front-level')?.value) || 15) / 100 : null,
              }, 1));
            }
            if (окноВкл) {
              const окно = плоскостиОкнаОбзора(b, {
                глубина: (Number($('vrt-win-depth')?.value) || 50) / 100,
                размер: (Number($('vrt-win-size')?.value) || 50) / 100,
                сдвигX: (Number($('vrt-win-x')?.value) || 0) / 100,
                сдвигZ: (Number($('vrt-win-z')?.value) || 0) / 100,
              });
              if (окно) список.push(...окно);
            }
            if (!список.length) {   // границы этого окна не читаются
              for (const п of оси) mapper.addClippingPlane(п);   // [12.0.57] чужое — на место
              запомнитьПлоскости(mapper, оси.map((п) => ({ origin: п.getOrigin(), normal: п.getNormal() })));
              continue;
            }
            if (список.length > 6) {
              // Страховка на будущее: лучше показать шесть, чем пустой экран.
              log.warn(`[Отсечение] плоскостей ${список.length}, шейдер держит 6 — лишние отброшены`);
              список.length = 6;
            }
            // [12.0.57] Место под сечения осей: всего не больше шести. Своё
            // главнее (врач нажал его сейчас) — сечения осей, что не влезли,
            // снимаются, и об этом говорится вслух.
            if (список.length + оси.length > 6) {
              const лишних = список.length + оси.length - 6;
              оси.splice(оси.length - лишних, лишних);
              сеченийСнято = true;
            }
            for (const п of список) mapper.addClippingPlane(vtkPlane.newInstance({ origin: п.origin, normal: п.normal }));
          }
          for (const п of оси) mapper.addClippingPlane(п);   // [12.0.57] чужие — обратно
          // [12.0.51] Cornerstone считает первые две плоскости маппера своими
          // «плоскостями камеры» и при повороте вида переставляет их в тонкий
          // слой у фокуса — объём превращался в срез. Сторож возвращает наши
          // числа сразу после такой перестановки (core/clipGuard.js).
          // [12.0.57] Помнится весь список маппера, вместе с сечениями осей.
          const всё = mapper.getClippingPlanes?.() || [];
          if (всё.length) {
            запомнитьПлоскости(mapper, всё.map((п) => ({ origin: п.getOrigin(), normal: п.getNormal() })));
            стеречьОкно(vp.element);
          }
          vp.render?.();
          легло++; имена.push(vp.id);
        } catch (eо) { log.debug(`[Убрать стол] окно ${vp?.id}:`, eо.message); }
      }
      if (сеченийСнято) showToast('Сечения X/Y/Z («Спец. режимы») сняты: шейдер объёма держит не больше шести плоскостей', 'warning', 5000);
      if (включено && !легло) {
        return { ок: false, стадия: 'окно-пустое', причина: 'Границы объёма не читаются — попробуйте после полной загрузки' };
      }
      log.info(`[Убрать стол] ${включено ? 'отсечение' : 'возврат'} в окнах: ${легло} (${имена.join(', ')})`);
      return { ок: true };
    } catch (e) {
      log.warn('[Убрать стол]', e.message);
      return { ок: false, стадия: 'нет-окна', причина: 'Ошибка отсечения: ' + e.message };
    }
  };

  // [11.1.34] Переключатель двигается СРАЗУ, а при неудаче возвращается
  // назад с объяснением. Прежний порядок (сперва применить, потом двигать)
  // выглядел как мёртвая кнопка: врач жмёт — ничего не происходит.
  const _показатьСостояние = (кнопка, вкл) => {
    кнопка.classList.toggle('on', вкл);
    кнопка.setAttribute('aria-checked', String(вкл));
    const ряд = $('vrt-crop-row');
    if (ряд) ряд.style.display = вкл ? '' : 'none';
    // [11.1.35] Мобильный двойник — немое зеркало: состояние ему показывает
    // ТОЛЬКО этот хозяин, свой логики у двойника нет (data-proxy кликает сюда).
    const дв = $('vrt-crop-table-m');
    if (дв) { дв.classList.toggle('on', вкл); дв.setAttribute('aria-checked', String(вкл)); }
    const рядМ = $('vrt-crop-row-m');
    if (рядМ) рядМ.style.display = вкл ? '' : 'none';
  };
  // [11.1.35] Метка «у тумблера есть хозяин»: общий перещёлкиватель
  // bindToggles обходит помеченные стороной — иначе он сбрасывал класс
  // обратно сразу после этого обработчика (см. надгробие в bindToggles).
  if ($('vrt-crop-table')) $('vrt-crop-table').dataset.хозяин = 'sidebarBindings/УбратьСтол';
  if ($('vrt-crop-table-m')) $('vrt-crop-table-m').dataset.хозяин = 'sidebarBindings/УбратьСтол(зеркало)';
  on('vrt-crop-table', 'click', async (e) => {
    const кнопка = e.currentTarget;
    const вкл = !кнопка.classList.contains('on');
    _показатьСостояние(кнопка, вкл);           // сразу: кнопка живая
    // [12.0.31] Всегда «пересчитать по тумблерам»: выключение стола не должно
    // снимать срез передней стенки, если он включён.
    const р = await _применитьОтсечение(true);
    if (!р.ок) {
      _показатьСостояние(кнопка, !вкл);        // не вышло — честно вернуть
      showToast(р.причина, 'warning', 4500);
      return;
    }
    showToast(вкл ? 'Стол отсечён со стороны спины — ползунком «Глубина сзади» подберите уровень' : 'Стол возвращён', 'info', 2000);
  });
  on('vrt-crop-level', 'input', () => {
    if ($('vrt-crop-table')?.classList.contains('on')) _применитьОтсечение(true);
  });

  // [12.0.31] ПЕРЕДНЯЯ СТЕНКА — свой тумблер вместо выбора стороны. Хозяин
  // тот же, путь применения тот же: у отсечения один владелец.
  const _показатьПеред = (кнопка, вкл) => {
    кнопка.classList.toggle('on', вкл);
    кнопка.setAttribute('aria-checked', String(вкл));
    const ряд = $('vrt-crop-front-row');
    if (ряд) ряд.style.display = вкл ? '' : 'none';
    const дв = $('vrt-crop-front-m');
    if (дв) { дв.classList.toggle('on', вкл); дв.setAttribute('aria-checked', String(вкл)); }
    const рядМ = $('vrt-crop-front-row-m');
    if (рядМ) рядМ.style.display = вкл ? '' : 'none';
  };
  if ($('vrt-crop-front')) $('vrt-crop-front').dataset.хозяин = 'sidebarBindings/ПередняяСтенка';
  if ($('vrt-crop-front-m')) $('vrt-crop-front-m').dataset.хозяин = 'sidebarBindings/ПередняяСтенка(зеркало)';
  on('vrt-crop-front', 'click', async (e) => {
    const кнопка = e.currentTarget;
    const вкл = !кнопка.classList.contains('on');
    _показатьПеред(кнопка, вкл);
    const р = await _применитьОтсечение(true);
    if (!р.ок) {
      _показатьПеред(кнопка, !вкл);
      showToast(р.причина, 'warning', 4500);
      return;
    }
    showToast(вкл
      ? 'Передняя стенка снята — ползунком «Глубина спереди» подберите уровень. Срез плоский: по бокам стенка останется рамкой'
      : 'Передняя стенка возвращена', 'info', вкл ? 4500 : 2000);
  });
  on('vrt-crop-front-level', 'input', () => {
    if (_вкл('vrt-crop-front')) _применитьОтсечение(true);
  });
  on('vrt-crop-front-level-m', 'input', (e) => {
    const наст = $('vrt-crop-front-level');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('input', { bubbles: false }));
  });
  const _окноВкл = () => $('vrt-window-box')?.classList.contains('on');
  const _применитьОкно = async () => {
    const ряды = $('vrt-window-rows');
    if (ряды) ряды.style.display = _окноВкл() ? '' : 'none';
    // Окно живёт поверх среза: если тумблер стола выключен, включаем сам
    // расчёт с нулевым срезом, иначе плоскостям некуда лечь.
    const р = await _применитьОтсечение(true);   // [12.0.31] что включено — решают тумблеры
    if (!р.ок) showToast(р.причина, 'warning', 4500);
  };
  if ($('vrt-window-box')) $('vrt-window-box').dataset.хозяин = 'sidebarBindings/ОкноОбзора';
  on('vrt-window-box', 'click', async (e) => {
    const вкл = !e.currentTarget.classList.contains('on');
    e.currentTarget.classList.toggle('on', вкл);
    e.currentTarget.setAttribute('aria-checked', String(вкл));
    await _применитьОкно();
    if (вкл) showToast('Окно обзора: видно только содержимое коробки. Пока оно включено, срезы стола и передней стенки не применяются — шейдер держит ровно 6 плоскостей, а у коробки их 6.', 'info', 6000);
  });
  for (const п of ['vrt-win-depth', 'vrt-win-size', 'vrt-win-x', 'vrt-win-z']) {
    on(п, 'input', () => { if (_окноВкл()) _применитьОтсечение(true); });
  }
  // [11.1.36] Мобильный ползунок уровня — напрямую к хозяину (см. надгробие
  // у «Плотности тканей» выше: цепочка data-sync-input не жила на телефоне).
  on('vrt-crop-level-m', 'input', (e) => {
    const наст = $('vrt-crop-level');
    if (!наст) return;
    наст.value = e.target.value;
    наст.dispatchEvent(new Event('input', { bubbles: false }));
  });

  // [11.1.36] ПЕРЕПРИМЕНЕНИЕ ОТСЕЧЕНИЯ. Плоскость живёт НА МАППЕРЕ АКТЁРА,
  // а актёры пересобираются: повторная загрузка исследования («переподключаюсь»
  // — замечание владельца: тумблер вправо, процент на месте, а стол ВЕРНУЛСЯ),
  // смена раскладки, применение пресета. Тумблер оставался на экране правдой
  // о ЖЕЛАНИИ врача, но никто не переносил плоскость на новый актёр. Теперь
  // хозяин слушает шину и, если тумблер включён, кладёт плоскость заново —
  // с повторами, пока объём подаётся в окна; если ни одно окно не примет
  // плоскости совсем (кинематический режим), тумблер честно выключается и
  // причина говорится вслух один раз.
  let _переприменениеИдёт = false;
  const _переприменитьОтсечение = async (попыток = 8) => {
    const кнопка = $('vrt-crop-table');
    // [12.0.31] Переносить есть что, если включена хоть одна сторона или окно.
    if (!_вкл('vrt-crop-table') && !_вкл('vrt-crop-front') && !_вкл('vrt-window-box')) return;
    if (_переприменениеИдёт) return;
    _переприменениеИдёт = true;
    try {
      for (let i = 0; i < попыток; i++) {
        const р = await _применитьОтсечение(true);
        if (р.ок) return;
        if (р.стадия === 'нет-маппера') {
          if (кнопка) _показатьСостояние(кнопка, false);
          const перед = $('vrt-crop-front');   // [12.0.31] и передняя стенка тоже
          if (перед) _показатьПеред(перед, false);
          showToast('Отсечение выключено: ' + р.причина, 'warning', 5000);
          return;
        }
        // окно-пустое / нет-окна — объём ещё едет; подождать и повторить
        await new Promise((r) => setTimeout(r, 400));
      }
      log.info('[Убрать стол] переприменение: окна так и не приняли объём — оставляю до следующего события');
    } finally { _переприменениеИдёт = false; }
  };
  busOn(BUS.VOLUME_LOAD_DONE, () => _переприменитьОтсечение());
  busOn(BUS.LAYOUT_CHANGED, () => _переприменитьОтсечение());
  busOn(BUS.PRESET_CHANGED, () => _переприменитьОтсечение());

  // ══ [11.1.26] ПРОФИЛИ УЧРЕЖДЕНИЙ в настройках бланка ══
  const _наполнитьПрофили = (выбрать = '') => {
    const сел = $('blank-profile-pick');
    if (!сел) return;
    const п = прочитатьПрофили();
    сел.innerHTML = '<option value="">— профиль учреждения —</option>'
      + п.map((x) => `<option value="${x.имя.replace(/"/g, '&quot;')}"${x.имя === выбрать ? ' selected' : ''}>${x.имя}</option>`).join('');
  };
  // [11.1.30] Списки шрифтов наполняются из каталога reportBlank — в
  // разметке их нет намеренно: два списка (шапка/тело) разошлись бы, как
  // когда-то гриды чипов W/L (11.1.17).
  const _наполнитьШрифты = () => {
    for (const id of ['blank-font-head', 'blank-font-body']) {
      const сел = $(id);
      if (сел && !сел.options.length) сел.innerHTML = ШРИФТЫ.map((ш) => `<option value="${ш}">${ш}</option>`).join('');
    }
  };
  /**
   * [11.1.31] ЕДИНСТВЕННЫЙ заполнитель модалки бланка. Хозяев было ДВА:
   * featureBindings.показатьНастройкиБланка (старый, знал только четыре
   * поля) и этот. Открывал модалку первый — поэтому шрифты, ширина и место
   * логотипа на экране оставались пустыми, хотя в коде были (замечание
   * владельца со скриншотом). Порода известная: «один хозяин у контрола».
   */
  const _вФорму = (б) => {
    if ($('blank-org')) $('blank-org').value = б.учреждение || '';
    if ($('blank-req')) $('blank-req').value = б.реквизиты || '';
    if ($('blank-depts')) $('blank-depts').value = Object.entries(б.отделения || {}).map(([к, з]) => `${к} = ${з}`).join('\n');
    if ($('blank-docs')) $('blank-docs').value = (б.врачи || []).map((в) => `${в.фио} = ${в.должность || ''}`).join('\n');
    const прев = $('blank-logo-prev');
    if (прев) { прев.src = б.логотип || ''; прев.style.display = б.логотип ? '' : 'none'; }
    // [11.1.30] Вид логотипа, шрифты, автооткрытие
    _наполнитьШрифты();
    const л = логотипБланка(б); const ш = шрифтыБланка(б);
    if ($('blank-logo-width')) { $('blank-logo-width').value = л.ширинаМм; }
    if ($('blank-logo-width-val')) $('blank-logo-width-val').textContent = л.ширинаМм + ' мм';
    if ($('blank-logo-place')) $('blank-logo-place').value = л.место;
    if ($('blank-font-head')) $('blank-font-head').value = ш.шапкаИмя;
    if ($('blank-font-head-size')) $('blank-font-head-size').value = ш.шапкаПт;
    if ($('blank-font-body')) $('blank-font-body').value = ш.телоИмя;
    if ($('blank-font-body-size')) $('blank-font-body-size').value = ш.телоПт;
    if ($('blank-open-after-save')) $('blank-open-after-save').checked = б.открыватьПослеСохранения !== false;
    // [11.1.35] Поля листа (просьба владельца: 1,5 см по умолчанию + настройка)
    const пл = поляБланка(б);
    if ($('blank-margin-top')) $('blank-margin-top').value = пл.верхМм;
    if ($('blank-margin-bottom')) $('blank-margin-bottom').value = пл.низМм;
    if ($('blank-margin-left')) $('blank-margin-left').value = пл.левоМм;
    if ($('blank-margin-right')) $('blank-margin-right').value = пл.правоМм;
    // Галочки разделов формы — из профиля (пусто = все включены)
    document.querySelectorAll('#report-sections input[data-section]').forEach((г) => {
      const карта = б.разделы || {};
      г.checked = !Object.keys(карта).length || карта[г.dataset.section] !== false;
    });
  };
  // Модалку открывает featureBindings, а наполняет — этот заполнитель.
  window.__mikhmelЗаполнитьБланк = () => _вФорму(прочитатьБланк());

  on('blank-logo-width', 'input', (e) => {
    const п = $('blank-logo-width-val'); if (п) п.textContent = e.target.value + ' мм';
  });
  const _изФормы = () => ({
    // [11.1.30] Вид логотипа, шрифты, автооткрытие и набор разделов едут
    // ВМЕСТЕ с учреждением: это части одного бланка, и в файл профиля они
    // должны попадать одним куском — иначе перенос на другой компьютер
    // привезёт шапку без её же оформления.
    логотипВид: {
      ширинаМм: Number($('blank-logo-width')?.value) || 22,
      место: $('blank-logo-place')?.value || 'слева',
    },
    шрифты: {
      шапкаИмя: $('blank-font-head')?.value || 'Times New Roman',
      шапкаПт: Number($('blank-font-head-size')?.value) || 12,
      телоИмя: $('blank-font-body')?.value || 'Times New Roman',
      телоПт: Number($('blank-font-body-size')?.value) || 12,
    },
    открыватьПослеСохранения: $('blank-open-after-save') ? !!$('blank-open-after-save').checked : true,
    разделы: Object.fromEntries([...document.querySelectorAll('#report-sections input[data-section]')]
      .map((г) => [г.dataset.section, !!г.checked])),
    учреждение: $('blank-org')?.value || '',
    реквизиты: $('blank-req')?.value || '',
    логотип: $('blank-logo-prev')?.src?.startsWith('data:') ? $('blank-logo-prev').src : '',
    отделения: Object.fromEntries(($('blank-depts')?.value || '').split('\n').map((с) => с.split('=')).filter((ч) => ч.length >= 2 && ч[0].trim()).map((ч) => [ч[0].trim().toUpperCase(), ч.slice(1).join('=').trim()])),
    врачи: ($('blank-docs')?.value || '').split('\n').map((с) => с.split('=')).filter((ч) => ч.length >= 2 && ч[0].trim()).map((ч) => ({ фио: ч[0].trim(), должность: ч.slice(1).join('=').trim() })),
  });
  on('blank-profile-pick', 'change', (e) => {
    const п = прочитатьПрофили().find((x) => x.имя === e.target.value);
    if (!п) return;
    _вФорму(п.бланк);
    showToast(`Профиль «${п.имя}» подставлен — нажмите «Сохранить», чтобы применить к отчётам`, 'info', 3000);
  });
  on('btn-blank-profile-save', 'click', async () => {
    const { спроситьТекст } = await import('../utils/helpers.js');
    const имя = await спроситьТекст('Название профиля учреждения:', { поУмолчанию: ($('blank-org')?.value || '').split('\n').find((с) => с.trim()) || '' });
    if (!имя) return;
    const р = сохранитьПрофиль(имя, _изФормы());
    if (!р.ок) { showToast(р.причина, 'error', 3000); return; }
    _наполнитьПрофили(имя.trim());
    showToast(`Профиль «${имя.trim()}» сохранён (всего ${р.всего})`, 'success', 2500);
  });
  on('btn-blank-profile-del', 'click', () => {
    const имя = $('blank-profile-pick')?.value;
    if (!имя) { showToast('Сначала выберите профиль в списке', 'info', 2000); return; }
    if (!confirm(`Удалить профиль «${имя}»? Поля формы останутся как есть.`)) return;
    удалитьПрофиль(имя);
    _наполнитьПрофили();
    showToast('Профиль удалён', 'info', 1800);
  });
  on('btn-blank-profile-export', 'click', async () => {
    const { downloadBlob } = await import('../utils/helpers.js');
    const профили = прочитатьПрофили();
    if (!профили.length) { showToast('Профилей ещё нет — сперва «Сохранить как…»', 'info', 2500); return; }
    downloadBlob(new Blob([собратьФайлПрофилей(профили)], { type: 'application/json' }), `бланки_учреждений_${new Date().toISOString().slice(0, 10)}.json`);
    showToast(`Выгружено профилей: ${профили.length}`, 'success', 2500);
  });
  on('btn-blank-profile-import', 'click', () => $('blank-profile-file')?.click());
  on('blank-profile-file', 'change', async (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    const р = разобратьФайлПрофилей(await файл.text());
    e.target.value = '';
    if (!р.ок) { showToast(р.причина, 'error', 4000); return; }
    // Слияние, а не замена: чужой файл не должен стирать свои бланки.
    const было = прочитатьПрофили();
    const слито = [...было.filter((с) => !р.профили.some((н) => н.имя === с.имя)), ...р.профили]
      .sort((a, b) => a.имя.localeCompare(b.имя, 'ru'));
    записатьПрофили(слито);
    _наполнитьПрофили(р.профили[0]?.имя || '');
    if (р.профили.length === 1) _вФорму(р.профили[0].бланк);
    showToast(`Загружено профилей: ${р.профили.length}. Выберите нужный и нажмите «Сохранить»`, 'success', 4000);
  });
  _наполнитьПрофили();

  // ══ [11.1.31] СПРАВОЧНИКИ БЛАНКА: контраст, аппараты, даты ══
  const _наполнитьСправочники = () => {
    const мод = (() => { try { return (_ctx?.getAllSeries?.() || [])[0]?.modality || ''; } catch (e) { return ''; } })();
    const кон = $('list-contrasts');
    if (кон) кон.innerHTML = контрастыДляМодальности(мод).map((к) => `<option value="${к.replace(/"/g, '&quot;')}">`).join('');
    const апп = $('list-devices');
    if (апп) апп.innerHTML = аппаратыДляМодальности(мод).map((а) => `<option value="${а.replace(/"/g, '&quot;')}">`).join('');
  };
  _наполнитьСправочники();
  // Открыли вкладку «Отчёты» — пересобрать под модальность текущего снимка:
  // на МР первым делом нужен гадолиний, на КТ — йод.
  document.querySelector('.right-tab[data-tab="tab-report"]')
    ?.addEventListener('click', () => setTimeout(_наполнитьСправочники, 80), { signal: _getSignal() });

  // Даты: точки расставляются на лету, ошибка называется словами и краснит поле.
  for (const id of ['report-birth', 'report-studydate']) {
    const поле = $(id);
    if (!поле) continue;
    поле.addEventListener('input', (e) => {
      const было = e.target.value;
      const стало = маскаДаты(было);
      if (стало !== было) e.target.value = стало;
      e.target.style.borderColor = '';
      e.target.title = '';
    }, { signal: _getSignal() });
    поле.addEventListener('blur', (e) => {
      const р = проверитьДату(e.target.value);
      e.target.style.borderColor = р.ок ? '' : '#ef4444';
      e.target.title = р.ок ? '' : р.причина;
      if (!р.ок) showToast(`${id === 'report-birth' ? 'Дата рождения' : 'Дата исследования'}: ${р.причина}`, 'warning', 3000);
    }, { signal: _getSignal() });
  }

  on('ann-color', 'input', (e) => {
    const v = $('ann-color-val'); if (v) v.textContent = e.target.value;
    _применитьСтиль({ color: e.target.value });
  });
  on('ann-line-width', 'change', (e) => _применитьСтиль({ lineWidth: e.target.value }));
  on('ann-font-size', 'change', (e) => _применитьСтиль({ fontSize: e.target.value }));
  // [12.0.57] Слушатели ползунков clip-x/y/z отсюда УБРАНЫ: у ползунка было
  // два хозяина — этот (ставил плоскость) и featureBindings (зажигал
  // выключатель оси), — и каждое движение собирало плоскости дважды. Хозяин
  // теперь один — featureBindings.bindSpecialModes: он и режет, и зажигает
  // выключатель, и говорит вслух, если резать некуда.

  _подключитьОбъём3D();
  _подключитьЭндоскопию();
}

/**
 * «Объём 3D»: порог ISO и общая прозрачность — теперь настоящие. [11.0.2]
 *
 * ЧТО БЫЛО. Оба ползунка меняли цифру рядом с собой и больше ничего: имена
 * `vol-iso` и `vol-opacity` встречались в проекте дважды — здесь и в таблице
 * подписей appInit. Раздел «Объём 3D» состоял из двух вывесок.
 *
 * ЧТО ДЕЛАЮТ. Правят кривую прозрачности объёмного актёра — тем же способом,
 * каким её правят МР-переносы (viewport.js:625) и редактор передаточной
 * функции этажом выше в этом же файле. Кривая строится в две точки: ниже
 * порога ISO объём прозрачен, выше — виден с заданной прозрачностью. Это
 * честный порог, а не «изоповерхность» в смысле марширующих кубов: для
 * поверхности есть отдельная кнопка «Построить поверхность» на вкладке
 * вычислений.
 *
 * КОНФЛИКТ С ПРЕСЕТАМИ — И ЧТО С НИМ СДЕЛАНО. Ту же кривую задают VRT-пресеты
 * левого сайдбара и редактор передаточной функции. Молча стирать чужую работу
 * нельзя в обе стороны, поэтому:
 *   • ползунок правит кривую только когда его двигают — не при загрузке, не
 *     при смене серии, не сам по себе;
 *   • ПРИМЕНЁННЫЙ ПРЕСЕТ ГЛАВНЕЕ: после `set3DPreset`/`applyRenderPreset`
 *     ползунки встают в положение, соответствующее новой кривой (см.
 *     `_снятьСКривой`), а не остаются показывать своё старое число. Иначе
 *     подпись врала бы о том, что на экране.
 * То есть последнее слово всегда за тем, к чему прикоснулись последним, и
 * подпись это слово повторяет.
 */
function _подключитьОбъём3D() {
  const iso = $('vol-iso'), прозр = $('vol-opacity');
  if (!iso && !прозр) return;

  /** Свойство объёмного актёра активного 3D-окна. */
  const свойство = () => {
    const re = getRenderingEngine();
    if (!re) return null;
    const id = find3DViewportId();
    if (!id) return null;
    const vp = re.getViewport(id);
    const запись = vp?.getDefaultActor?.() || vp?.getActors?.()?.[0];
    const prop = запись?.actor?.getProperty?.();
    return prop ? { vp, prop } : null;
  };

  const применить = () => {
    const о = свойство();
    if (!о) {
      showToast('Объёма нет: откройте исследование и включите режим 3D', 'warning', 3500);
      return false;
    }
    const порог = Number(iso?.value ?? 300);
    const альфа = Math.max(0, Math.min(1, Number(прозр?.value ?? 80) / 100));
    try {
      const кривая = о.prop.getScalarOpacity?.(0);
      if (!кривая?.removeAllPoints) { showToast('Это окно не даёт править прозрачность объёма', 'warning', 3000); return false; }
      кривая.removeAllPoints();
      // Узкая ступень перед порогом (1 % диапазона, но не меньше 1 HU): резкая
      // граница даёт «лесенку» на срезах, слишком мягкая — туман вместо формы.
      const ступень = Math.max(1, Math.abs(порог) * 0.01);
      кривая.addPoint(порог - ступень, 0);
      кривая.addPoint(порог, альфа);
      кривая.addPoint(3071, альфа);
      о.vp.render?.();
      // [12.0.51] Здесь стояло `_crCache?.forceRender?.()`. Такой переменной в
      // этой функции нет (она живёт внутри bindCinematicPanel), а `?.` от
      // необъявленного имени не спасает: ReferenceError ловился ниже, и после
      // УЖЕ применённой кривой врач каждый раз видел «Не удалось изменить
      // объём: _crCache is not defined». Рендерер берётся у хозяина.
      getCinematicRenderer()?.forceRender?.();
      return true;
    } catch (e) {
      log.warn('[Объём 3D]', e.message);
      showToast('Не удалось изменить объём: ' + e.message, 'error', 3500);
      return false;
    }
  };

  if (iso) iso.addEventListener('change', применить, { signal: _ac.signal });
  if (прозр) прозр.addEventListener('change', применить, { signal: _ac.signal });

  /**
   * Подтянуть ползунки под кривую, которую поставил кто-то другой.
   * Зовётся после применения пресета: см. оговорку о конфликте выше.
   */
  window.__волОбъёмСнятьСКривой = () => {
    const о = свойство();
    if (!о) return;
    try {
      const кривая = о.prop.getScalarOpacity?.(0);
      const n = кривая?.getSize?.() ?? 0;
      if (!n) return;
      // Порог — первая точка, где прозрачность перестаёт быть нулевой;
      // альфа — наибольшее значение кривой.
      let порог = null, максАльфа = 0;
      const буфер = [0, 0, 0, 0];
      for (let i = 0; i < n; i++) {
        кривая.getNodeValue(i, буфер);
        const [x, y] = буфер;
        if (y > максАльфа) максАльфа = y;
        if (порог === null && y > 0.01) порог = x;
      }
      if (порог !== null && iso) { iso.value = String(Math.round(порог)); const v = $('vol-iso-val'); if (v) v.textContent = iso.value; }
      if (максАльфа > 0 && прозр) { прозр.value = String(Math.round(максАльфа * 100)); const v = $('vol-opacity-val'); if (v) v.textContent = прозр.value + '%'; }
    } catch (e) { log.debug('[Объём 3D] снять с кривой:', e.message); }
  };
}

/**
 * «3D Эндоскопия»: ползунки «Позиция» и «FOV».
 *
 * [12.0.51] Проводка 12.0.50 звала камеру, но картинка не менялась (почему —
 * надгробие в core/viewportCamera.js у setEndoscopyCamera). Теперь:
 *   • «Позиция» 0% — обычный вид снаружи; 1…100% — камера внутри объёма на
 *     линии взгляда через центр окна, перспектива; возврат на 0% отдаёт вид
 *     ровно таким, каким он был до входа;
 *   • «FOV» — угол обзора камеры внутри; снаружи (0%) он не действует — 3D-окно
 *     там в параллельной проекции, и об этом говорится один раз;
 *   • отказ (линия взгляда мимо объёма, нет 3D-окна) возвращает ползунок на 0
 *     и называет причину — ползунок не остаётся стоять на числе, которого нет;
 *   • новая раскладка или новый объём — окно пересоздано, вход забывается и
 *     ползунок встаёт на 0.
 */
function _подключитьЭндоскопию() {
  const позиция = $('endo-position'), fov = $('endo-fov');
  if (!позиция && !fov) return;

  const наНоль = () => {
    if (!позиция) return;
    позиция.value = '0';
    const подпись = $('endo-pos-val');
    if (подпись) подпись.textContent = '0%';
  };
  let последнееОкно = null;
  let fovСнаружиСказано = false;

  const применить = (откуда) => {
    const id = find3DViewportId();
    if (!id) {
      наНоль();
      showToast('Эндоскопия: нужно объёмное 3D-окно — откройте раскладку MPR 6 или режим 3D', 'warning', 3500);
      return;
    }
    const p = Number(позиция?.value ?? 0);
    const f = fov ? Number(fov.value) : 90;
    if (p === 0) {
      setEndoscopyCamera(id, 0, f);
      if (откуда === 'fov' && !fovСнаружиСказано) {
        fovСнаружиСказано = true;
        showToast('Угол обзора действует, когда камера внутри объёма: сдвиньте «Позицию» больше 0%', 'info', 4500);
      }
      return;
    }
    const р = setEndoscopyCamera(id, p, f);
    if (!р.ok) {
      наНоль();
      showToast('Эндоскопия: ' + р.причина, 'warning', 4500);
      return;
    }
    последнееОкно = id;
  };

  if (позиция) позиция.addEventListener('input', () => применить('позиция'), { signal: _ac.signal });
  if (fov) fov.addEventListener('input', () => применить('fov'), { signal: _ac.signal });

  // Новый объём в том же окне — выйти наружу (вид до входа). Новая
  // раскладка — окно пересоздано, камеру возвращать некуда, только забыть.
  const выйти = (вернуть) => () => {
    if (последнееОкно) resetEndoscopyCamera(последнееОкно, { вернуть });
    последнееОкно = null;
    наНоль();
  };
  busOn(BUS.VOLUME_LOAD_DONE, выйти(true));
  busOn(BUS.LAYOUT_CHANGED, выйти(false));
}

// ============================================================
// ALL TOGGLES
// ============================================================
function bindToggles() {
  // [11.1.35] НАДГРОБИЕ ВТОРОГО ХОЗЯИНА. Этот общий перещёлкиватель молча
  // щёлкал класс И У ТЕХ тумблеров, у которых есть СОБСТВЕННЫЙ обработчик.
  // На «Убрать стол» это давало ровно то, что видел владелец: свой
  // обработчик двигал тумблер и применял отсечение, а следом срабатывал
  // этот и СБРАСЫВАЛ класс назад — отсечение на экране есть, тумблер
  // выглядит выключенным. Та же болезнь, что уже хоронили в appInit
  // (надгробие 10.19.30), только тогда лишним был appInit, а теперь —
  // сам общий перещёлкиватель для тумблеров с хозяином.
  //
  // Правило, а не список имён: тумблер с собственным обработчиком помечает
  // себя data-атрибутом «хозяин» В МОМЕНТ ПРИВЯЗКИ, и общий перещёлкиватель
  // его не трогает. Проверка — в момент КЛИКА, а не привязки: хозяева из
  // других модулей (featureBindings, proFeaturesBindings) вешаются позже
  // этой функции, и проверка при привязке их бы не увидела.
  onAll('.ctrl-toggle', 'click', (e) => {
    if (e.currentTarget.dataset.хозяин) return;
    e.currentTarget.classList.toggle('on');
    // role="switch" обязан говорить правду и читалке экрана, не только глазу.
    e.currentTarget.setAttribute('aria-checked', String(e.currentTarget.classList.contains('on')));
  });
}

// ─── TRANSFER FUNCTION EDITOR ────────────────────────────────
function bindTFEditor() {
  // Callback: применяет пресет-объект к текущему Volume3D viewport
  const applyTF = (presetObj) => {
    const re = getRenderingEngine();
    if (!re) return;
    // Ищем Volume3D viewport
    for (const vpId of getViewportIds()) {
      const vp = re.getViewport(vpId);
      const actorEntry = vp?.getDefaultActor?.() || vp?.getActors?.()[0];
      if (vp && actorEntry?.actor?.getProperty) {
        try {
          const property = actorEntry.actor.getProperty();

          // RGB Transfer Function
          const ctfun = property.getRGBTransferFunction?.(0);
          if (ctfun?.removeAllPoints) {
            ctfun.removeAllPoints();
            for (const [hu, r, g, b] of presetObj.color) ctfun.addRGBPoint(hu, r, g, b);
          }

          // Scalar Opacity
          const ofun = property.getScalarOpacity?.(0);
          if (ofun?.removeAllPoints) {
            ofun.removeAllPoints();
            for (const [hu, alpha] of presetObj.opacity) ofun.addPoint(hu, alpha);
          }

          // Gradient Opacity
          if (presetObj.gradient && property.getGradientOpacity) {
            try {
              const gofun = property.getGradientOpacity(0);
              if (gofun?.removeAllPoints) {
                gofun.removeAllPoints();
                for (const [mag, alpha] of presetObj.gradient) gofun.addPoint(mag, alpha);
              }
              property.setUseGradientOpacity?.(0, true);
            } catch (e) { log.debug('[SidebarBindings]', e.message); }
          } else {
            property.setUseGradientOpacity?.(0, false);
          }

          // Shading
          property.setShade?.(presetObj.shade ?? true);
          property.setAmbient?.(presetObj.ambient ?? 0.2);
          property.setDiffuse?.(presetObj.diffuse ?? 0.8);
          property.setSpecular?.(presetObj.specular ?? 0.2);
          property.setSpecularPower?.(presetObj.specularPower ?? 10);

          vp.render();
        } catch (e) {
          log.warn('[TFEditor] Apply error:', e);
        }
      }
    }
  };

  // Инициализируем редактор
  initTFEditor(applyTF);

  // Click handler is in main.js — no duplicate here
}

// ─── LEFT PANEL VRT → RIGHT PANEL (синхронизация) ─────────────
function bindLeftPanelVRT() {
  // УДАЛЕНО: дублировало bindVRTSection() (строки 310-318)
}

// ─── LEFT PANEL ORIENT → RIGHT PANEL ─────────────────────────
function bindLeftPanelOrient() {
  // УДАЛЕНО: дублировало bindVRTSection() (строки 320-339)
}

// ============================================================
// RULER / MINIMAP
// ============================================================
// [12.0.51] Выключатель «Миникарта» (toggle-minimap) и блок #minimap УДАЛЕНЫ.
// Выключатель показывал и прятал чёрный квадрат 120×120: холст minimap-canvas
// не рисовал никто (поиск по src/ — ни одного обращения), рамка minimap-indicator
// не двигалась. Включённая «миникарта» была пустым квадратом поверх окна.

// ============================================================
// HANGING PROTOCOLS
// ============================================================
// [12.0.51] Пункты называют то, что произойдёт; «Авто» берёт модальность
// открытой серии; отказ говорится словами (core/hangingLayout.js).
const _модальностьОткрытой = () => {
  try {
    const re = getRenderingEngine();
    for (const id of getViewportIds()) {
      const vp = re?.getViewport?.(id);
      const кадр = vp?.getCurrentImageId?.() || vp?.getImageIds?.()?.[0];
      const м = кадр && cornerstone?.metaData?.get?.('generalSeriesModule', кадр)?.modality;
      if (м) return String(м).toUpperCase();
    }
  } catch (e) { log.debug('[Протокол] модальность:', e.message); }
  return null;
};

function bindHangingProtocols() {
  on('hanging-protocol', 'change', (e) => {
    const р = раскладкаДляПротокола(e.target.value, _модальностьОткрытой());
    if (!р.раскладка) { showToast('Протокол: ' + р.причина, 'warning', 4000); return; }
    changeLayout(р.раскладка);
    showToast(`Раскладка ${р.раскладка.replace('x', '×').toUpperCase()} (${р.пояснение})`, 'info', 2000);
  });
}


// ══════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════
// ENTERPRISE FEATURES (v6) — W/L History, Clinical Workflows, Quick-apply
// ══════════════════════════════════════════════════════════════

/** @type {Array<{ww:number, wc:number, timestamp:number, label:string}>} */
const _wlHistory = [];
const WL_HISTORY_MAX = 20;

/**
 * Push current W/L to history stack (called internally on every W/L change)
 * @param {number} ww
 * @param {number} wc
 * @param {string} [label='']
 */
export function pushWLHistory(ww, wc, label = '') {
  _wlHistory.push({ ww, wc, timestamp: Date.now(), label });
  if (_wlHistory.length > WL_HISTORY_MAX) _wlHistory.shift();
}

/**
 * Get W/L history
 * @returns {Array}
 */
export function getWLHistory() { return [..._wlHistory]; }

/**
 * Restore previous W/L from history
 * @param {number} [index=-1] — -1 = last
 */
export function restoreWLFromHistory(index = -1) {
  const entry = index < 0 ? _wlHistory[_wlHistory.length + index] : _wlHistory[index];
  if (!entry) { showToast('❌ Нет W/L в истории', 'warning'); return; }
  const re = getRenderingEngine();
  const vp = re?.getViewport(_ctx?.getCurrentViewportId?.());
  if (vp) {
    vp.setProperties({ voiRange: { lower: entry.wc - entry.ww / 2, upper: entry.wc + entry.ww / 2 } });
    vp.render();
    updateWLOverlay(entry.ww, entry.wc);
    showToast(`↩ W:${entry.ww} L:${entry.wc}`, 'info', 1000);
  }
}

/**
 * [11.0.2] ВТОРОЙ РЕЕСТР `CLINICAL_WORKFLOWS` УДАЛЁН — вместе с двумя
 * функциями при нём (`applyClinicalWorkflow`, `listClinicalWorkflows`).
 *
 * Он был мёртв: обе функции экспортировались и не вызывались НИГДЕ — ни в
 * src/, ни в тестах. Но мёртв опасно, по двум причинам сразу.
 *
 * ПЕРВАЯ: он носил имя живого реестра. Настоящий CLINICAL_WORKFLOWS живёт в
 * core/presetsManager.js, и именно из него берут сценарии кнопки «КТ Кости»,
 * «КТ Ангиография» и остальные (`_bindСценарии` ниже, через getWorkflow).
 * Ключи у двух реестров РАЗНЫЕ: здесь были 'bone-ct', 'chest-ct', там —
 * 'workflow-ct-bone', 'workflow-ct-chest'. Тот, кто нашёл бы этот по имени,
 * получил бы другой набор.
 *
 * ВТОРАЯ, и она хуже: здесь лежали ЗАШИТЫЕ ЧИСЛА ОКНА — ww/wc прямо в
 * записях. При этом комментарий к живому связывателю восемьюдесятью строками
 * ниже обещает: «ТОЛЬКО реестр CLINICAL_WORKFLOWS… зашитых чисел здесь нет и
 * не будет (пин в enterprise_test)». Обещание было правдой про то место — и
 * неправдой про этот файл, где числа лежали всё это время.
 */

export function getSidebarBindingsState() {
  // [11.0.2] Поле `workflows` считало записи ВТОРОГО реестра
  // CLINICAL_WORKFLOWS — того самого, что удалён выше как мёртвый и опасный.
  // Ссылку я при удалении проглядел: синтаксис от этого не страдает, файл
  // разбирается, а падало бы на вызове — ReferenceError. Поймано КОНТРОЛЕМ
  // verify_11_0_3, а не глазами, и это ровно то, ради чего он написан.
  //
  // Считаем теперь живой реестр — тот, из которого работают кнопки сценариев.
  return { activeVRTPreset: _activeVRTPreset, builtinPresets: BUILTIN_VRT_PRESETS.length,
    userPresets: getUserVRTPresets().length, wlHistorySize: _wlHistory.length,
    workflows: Object.keys(CLINICAL_WORKFLOWS_РЕЕСТР || {}).length };
}
export function getActiveVRTPreset() { return _activeVRTPreset || ''; }
export function getBuiltinVRTPresets() { return [...BUILTIN_VRT_PRESETS]; }
export function getUserVRTPresetsAPI() { return getUserVRTPresets(); }
/**
 * [10.0.2] Сказать, КУДА лёг пресет. Раньше сообщение было просто названием
 * пресета, и человек не мог понять, почему изменилось не то, что он ждал.
 */
function _presetToast(label, res) {
  const name = String(label || '').trim();
  // [10.0.3] Если пресет пришлось подгонять под шкалу серии или он в неё не
  // попадает — говорим об этом. Молчаливое «применено» на чёрном окне и было
  // тем, что читалось как «пресет не работает».
  if (res?.notice) return `🎨 ${res.notice}`;
  if (res?.target === 'view-3d') return `🎨 ${name} → окно «3D · Пресет»`;
  if (res?.target) return `🎨 ${name} → объёмное окно`;
  if (res?.fallbackWL) return `🎨 ${name} → окно плотности на срезах (объёмного окна в раскладке нет)`;
  return `🎨 ${name}`;
}

export function applyVRTPresetById(presetId) {
  const p = _ctx?.VRT_PRESET_MAP?.[presetId] || { cs3d: presetId, ww: 400, wc: 40 };
  _activeVRTPreset = presetId;
  return applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
}
export function syncCinematicSlidersAPI() { _syncCinematicSliders(); }
export function openVRTPresetManagerAPI() { openVRTPresetManager(); openModal('modal-vrt-presets'); }


// [10.19.43] «Сравнение ракурсов — сделать достойной» (решение владельца,
// п.5): подсветка сохранённых видов честная — из ядра (getCameraABState),
// не из локальных флагов, которые лгали бы после пере-рендера панели.
function _bindРакурсы() {
  const кА = document.getElementById('btn-cam-a');
  const кБ = document.getElementById('btn-cam-b');
  const кАБ = document.getElementById('btn-cam-ab');
  if (!кА || !кБ || !кАБ) return;
  const окно = () => find3DViewportId();
  const свет = () => { const id = окно(); const st = id ? getCameraABState(id) : { a: false, b: false };
    кА.classList.toggle('active', st.a); кБ.classList.toggle('active', st.b); };
  кА.addEventListener('click', () => { const id = окно(); if (!id) { showToast('Нет объёмного окна — откройте MPR 6 или 3D', 'info', 1800); return; } setCameraA(id); showToast('🅰 Вид А сохранён', 'success', 1000); свет(); });
  кБ.addEventListener('click', () => { const id = окно(); if (!id) { showToast('Нет объёмного окна — откройте MPR 6 или 3D', 'info', 1800); return; } setCameraB(id); showToast('🅱 Вид Б сохранён', 'success', 1000); свет(); });
  кАБ.addEventListener('click', async () => { const id = окно(); if (!id) { showToast('Нет объёмного окна', 'info', 1500); return; }
    const st = getCameraABState(id);
    if (!st.a || !st.b) { showToast('Сначала сохраните Вид А и Вид Б', 'info', 2000); return; }
    await toggleCameraAB(id); свет(); });
  свет();
}

// [10.19.43] Сценарии — переезд из Enterprise (п.8). ТОЛЬКО реестр
// CLINICAL_WORKFLOWS: пресет 3D по имени записи и окно по имени пресета
// окна; зашитых чисел здесь нет и не будет (пин в enterprise_test).
// [12.0.6] Применение сценария ВЫНЕСЕНО в именованную функцию и экспортировано:
// раскладка под процедуру (рабочий список) обязана применять сценарий ТЕМ ЖЕ
// правилом, что кнопка в панели, — второй копии этой логики не заводим.
export function применитьСценарий(ключ) {
  const wf = getWorkflow(ключ);
  if (!wf) { showToast('Сценарий не найден в реестре', 'error', 2000); return { ok: false, причина: 'нет в реестре' }; }
  const применено = [];
  const окно3д = find3DViewportId();
  if (wf.preset3d?.id && окно3д) { try { set3DPreset(wf.preset3d.id); применено.push('3D'); } catch (err) { /* пресет 3D — не повод ронять окно */ } }
  const wp = wf.window?.id ? getWindowPreset(wf.window.id) : null;
  if (wp && wp.ww != null) {
    applyWindowToSlices({ ww: wp.ww, wc: wp.wc });
    // [12.0.48] Окно сценария — как окно чипа: надпись W/L на снимке, подсветка
    // чипов с теми же числами и ползунки ручного окна (через событие ниже).
    // Раньше после сценария надпись и ползунки показывали прежнее окно.
    updateWLOverlay(wp.ww, wp.wc);
    подсветитьЧипыОкна(wp.ww, wp.wc);
    try { document.dispatchEvent(new CustomEvent('mikhmel:окно-извне')); } catch (err) { /* */ }
    применено.push(`окно ${wp.ww}/${wp.wc}`);
  }
  showToast(`${wf.name}${применено.length ? ' · ' + применено.join(' + ') : ' — подходящих окон нет'}`, применено.length ? 'success' : 'info', 2200);
  return { ok: true, имя: wf.name, применено };
}

/**
 * [12.0.48] Подсветить ВСЕ чипы окна с этими числами (синонимы горят вместе —
 * то же правило, что при открытии серии в seriesPanel, аудит §2.4).
 */
function подсветитьЧипыОкна(ww, wc) {
  $$('.preset-chip[data-ww], .preset-chip[data-wl-auto]').forEach((c) => {
    const да = !c.dataset.wlAuto && parseInt(c.dataset.ww) === ww && parseInt(c.dataset.wc) === wc;
    c.classList.toggle('active', да);
    c.setAttribute('aria-pressed', String(да));
  });
}

function _bindСценарии() {
  // [12.0.48] Два ряда: правая панель (data-workflow) и мобильный ящик
  // (data-workflow-m). Подсказка и модальность каждой кнопки — из реестра:
  // модальность нужна presetModality, чтобы гасить сценарии КТ на МРТ и без
  // исследования (раньше кнопки жались всегда и клали КТ-окно куда угодно).
  for (const к of document.querySelectorAll('[data-workflow], [data-workflow-m]')) {
    const wf = getWorkflow(к.dataset.workflow || к.dataset.workflowM);
    if (!wf) continue;
    const wp = wf.window?.id ? getWindowPreset(wf.window.id) : null;
    к.dataset.wfModality = String(wf.modality || '').toUpperCase();
    к.setAttribute('title', `${wf.description || wf.name}${wp?.ww != null ? `. Окно на срезах W ${wp.ww}, L ${wp.wc}` : ''}`);
  }
  for (const id of ['wf-row', 'wf-row-m']) {
    const ряд = document.getElementById(id);
    if (!ряд) continue;
    ряд.addEventListener('click', (e) => {
      const к = e.target.closest('[data-workflow], [data-workflow-m]');
      if (!к || к.disabled) return;
      применитьСценарий(к.dataset.workflow || к.dataset.workflowM);
    });
  }
}
